import { AuthService } from '/auth-service.js';
import { UserSession } from '@stacks/auth';
import { AppConfig, showConnect, openContractCall } from '@stacks/connect';
import { STACKS_MAINNET, STACKS_TESTNET } from '@stacks/network';
import { bufferCV, boolCV, addressToString, Cl, deserializePrincipal, standardPrincipalCVFromAddress, intCV, uintCV, PostConditionMode, stringAsciiCV, principalCV, standardPrincipalCV, FungibleConditionCode, makeContractCall, broadcastTransaction, fetchCallReadOnlyFunction, READONLY_FUNCTION_CALL_PATH, cvToJSON, Pc } from '@stacks/transactions';
import WalletDropdown from './walletDropdown.js';
import gatedLogo from '/gated-logo2.png';
import blocktuneLogo from '/blocktune-logo.jpg';
import { NFTAudioIntegration } from './nftAvailability.js';
import loader from './loader.js';
import './nft-swap.js';
import { handlePageUpdate } from './pageConfig.js';
import { initNFTFallEffect } from './snowEffect.js';
import { EditSidebar } from './editSidebar.js';
import { MochineNFTManager } from './mochineNftContracts.js';
import { initNFTInteractions } from './mochineNftContracts.js';
import { MOCHINE_CONTRACTS } from './mochineNftContracts.js';
import { initializeDarkModeToggle, applyPageTheme } from './darkMode.js';
import roo from '/roo.png';
import { musicData, musicPlayer, albumMetadata } from './musicConfig.js';
import { renderPublicAlbumPage } from './album-page.js';
import { renderAlbumsSection } from './album-creator.js';
import { ProfilePhoto } from './profilePhoto.js';
import { renderStoreItems, fetchUserNFTs, handleMint, createMusicPlayerCard, togglePlayPause, loadTrack, playPreviousTrack, playNextTrack } from './script.js';  // Add this import
import track1Image from './audio/Josie_image.png';
import track1Audio from './audio/Track 1_ Josie Field - Radio Silence.wav';
import track2Image from './audio/Ard_image.png';
import track2Audio from './audio/Track 2_ Ard Matthews - You Make it Alright.wav';
import track3Image from './audio/Arno_image.png';
import track3Audio from './audio/Track 3_ Arno Carstens - Mortals.wav';
import track4Image from './audio/Kahn_image.png';
import track4Audio from './audio/Track 4_ Kahn Morbee - Buzzhead.wav';
import track5Image from './audio/Laurie_image.png';
import track5Audio from './audio/Track 5_ Laurie Levine - Grey.wav';
import track6Image from './audio/Jacques_image2.png';
import track6Audio from '/audio/Track 6_ Jacques Moolman - Exile.wav';
import track7Image from './audio/Evert_Image.png';
import track7Audio from './audio/Track 7_ Evert Snyman - I Shouldnt Break.wav';
import track8Image from './audio/Xander_image.png';
import track8Audio from './audio/Track 8_ Gazelle - BBQ to Braai.wav';
import albumImage from '/audio/Album_image.png';
import mochineBanner from '/mochines/Banner.png'


window.app = {
  showCreatePageModal: null,  // Initialize as null
  hideCreatePageModal: null   // Initialize as null
};

function sanitizeUrl(title) {
  return title
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/%20/g, '-') // Replace %20 with hyphens
    .replace(/[^a-z0-9-]/g, '') // Remove special characters
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens

}

function createSettingsMenu(page) {
  return `
    <div class="settings-menu hidden" data-page-id="${page.id}">
    </div>
  `;
}

// Create a metadata cache
const metadataCache = new Map();

// Load cache from localStorage if available
try {
  const storedCache = localStorage.getItem('metadataCache');
  if (storedCache) {
    const parsedCache = JSON.parse(storedCache);
    if (parsedCache.timestamp && Date.now() - parsedCache.timestamp < 24 * 60 * 60 * 1000) {
      Object.entries(parsedCache.data).forEach(([key, value]) => {
        metadataCache.set(key, value);
      });
      console.log(`Loaded ${metadataCache.size} items from cache`);
    }
  }
} catch (e) {
  console.error('Failed to load cache from localStorage:', e);
}

// List of fast IPFS gateways
const ipfsGateways = [
  'https://nftstorage.link/ipfs/',
  'https://gateways.pinata.cloud/ipfs/',
  'https://dweb.link/ipfs/',
  'https://ipfs.io/ipfs/'
];


export class Router {

  constructor() {
    // Route definitions
    this.routes = [];
    // Cache for pages and media to avoid re-fetch on tab switch
    this.cachedPages = null;
    this.cachedMedia = null;
    // Current STX address of signed-in user
    this.currentStxAddress = null;
    this.mainContent = document.getElementById('main-content');
    if (!this.mainContent) {
      this.mainContent = document.createElement('div');
      this.mainContent.id = 'main-content';
      document.body.appendChild(this.mainContent);
    }

    this.sanitizeUrl = (str) => str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    this.owner = window.stxAddress;
    this.pendingUpdates = new Set();
    this.currentEffect = null;

    // Bind the methods to this instance
    window.app.showCreatePageModal = () => this.showCreatePageModal();
    window.app.hideCreatePageModal = () => this.hideCreatePageModal();

    try {
      // Initialize auth first
      console.log('1. Creating AuthService');

      this.auth = new AuthService(this);
      console.log('2. Get STX address', this.auth.currentAddress)
      // Initialize everything else only after auth is ready 
      this.initializeAfterAuth();
    } catch (error) {
      console.error('Failed to create AuthService:', error);
    }
  }

   async fetchMetadataUriFromContract(tokenId) {
    const result = await callReadOnlyFunction({
      contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5', // your actual address
      contractName: 'gated-pages', // or whatever your contract name is
      functionName: 'get-token-uri',
      functionArgs: [uintCV(tokenId)],
      senderAddress: 'SP1ZCYG0D3HCK2F7SY8VH9ZREB0JWCBSAPFNS8V5Z' // any valid address (can be this.stxAddress or a static one)
    });

    if (result.value?.value?.data) {
      return result.value.value.data;
    }

    return null;
  }

  async fetchPageMetadataByUri(metadataUri) {
    const cleaned = metadataUri.replace('ipfs://', 'https://ipfs.io/ipfs/');
    const res = await fetch(cleaned);
    if (!res.ok) throw new Error('Metadata fetch failed');
    return await res.json();
  }


  async initializeAfterAuth() {


    initNFTInteractions(this.auth);

    console.log('Checking existing session...');
    this.checkExistingSession();

    // Initialize route handlers immediately
    this.initializeRouteHandlers();

    // Initialize music player
    this.initializeMusicPlayer();

    // Set up route change listeners
    this.setupEventListeners();

    // Set up wallet functions
    this.setupWalletFunctions();

    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }

    console.log('Router initialization completed');
  }

  initNFTInteractions() {
    const nftManager = new MochineNFTManager(authService);
    const nfts = document.querySelectorAll('.nft-preview');

    // Add styles for availability indicators
    const style = document.createElement('style');
    style.textContent = `
    .nft-availability {
      margin: 10px 0;
      padding: 8px 12px;
      border-radius: 4px;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
    }
    .nft-availability.available {
      background-color: #ecfdf5;
      color: #047857;
      border: 1px solid #047857;
    }
    .nft-availability.sold-out {
      background-color: #fef2f2;
      color: #dc2626;
      border: 1px solid #dc2626;
    }
    .mint-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: #d1d5db;
    }
  `;
    document.head.appendChild(style);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeFullscreen();
      }
    });

    function closeFullscreen() {
      const fullscreenNFT = document.querySelector('.nft-preview.fullscreen');
      if (fullscreenNFT) {
        fullscreenNFT.classList.remove('fullscreen');
        fullscreenNFT.querySelector('.fullscreen-content')?.remove();
      }
    }

    nfts.forEach(preview => {
      const originalClickHandler = (e) => {
        // Don't trigger if clicking mint button
        if (e.target.classList.contains('mint-button')) {
          return;
        }

        // Remove any existing fullscreen content
        closeFullscreen();

        preview.classList.add('fullscreen');

        const container = document.createElement('div');
        container.className = 'fullscreen-content';

        const nftName = preview.getAttribute('data-name');
        const contractKey = preview.getAttribute('data-contract-key')
          .toUpperCase()
          .replaceAll(' ', '')
          .trim();

        // Get contract info and check availability
        const contractInfo = nftManager.getContractInfo(contractKey);
        const isAvailable = contractInfo?.available ?? false;

        console.log('Contract Key:', contractKey);
        console.log('Contract Info:', contractInfo);
        console.log('Availability:', isAvailable);

        const details = document.createElement('div');
        details.className = 'nft-details';

        // Create availability message based on status
        const availabilityStatus = isAvailable
          ? '<div class="nft-availability available">Available for Minting</div>'
          : '<div class="nft-availability sold-out">Sold Out</div>';

        details.innerHTML = `
        <div class="nft-details-content">
          <h2 class="nft-title">${nftName}</h2>
          <h4 class="nft-title">1/1</h4>
          <div class="nft-price">Price: 20 STX</div>
          <div class="nft-artist">Artist: Reece Swanepoel</div>
          ${availabilityStatus}
          <button class="mint-button" ${!isAvailable ? 'disabled' : ''} data-contract="${contractKey}">
            ${isAvailable ? 'Mint NFT' : 'Sold Out'}
          </button>
        </div>
      `;

        const closeBtn = document.createElement('div');
        closeBtn.className = 'close-button';
        closeBtn.innerHTML = '×';

        container.appendChild(details);
        container.appendChild(closeBtn);
        preview.appendChild(container);

        // Add mint button listener only if NFT is available
        if (isAvailable) {
          const mintButton = details.querySelector('.mint-button');
          mintButton.addEventListener('click', async (e) => {
            e.stopPropagation();
            try {
              const response = await nftManager.mintNFT(contractKey);
              console.log('Minting response:', response);
              alert('NFT minting initiated! Check your wallet for confirmation.');
            } catch (error) {
              console.error('Minting error:', error);
              alert('Failed to mint NFT: ' + error.message);
            }
          });
        }

        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeFullscreen();
        });
      };

      preview.addEventListener('click', originalClickHandler);
    });

    // Debug: Log all contracts at initialization
    console.log('All NFT contracts:', nftManager.getAllContracts());
  }

  setupEventListeners() {
    window.addEventListener('hashchange', () => {
      console.log('Hash change detected');
      this.handleRoute();
    });

    window.addEventListener('popstate', () => {
      console.log('Pop state detected');
      this.handleRoute();
    });
  }

  createPageObject(pageData, tokenId, userAddressMainnet, blockHeight) {
    const isActive = typeof pageData.active === 'boolean'
      ? pageData.active
      : pageData.active?.type === 'true' ||
      pageData.active?.value === true ||
      pageData.active?.type === 3;

    return {
      type: 'page',
      id: tokenId,
      owner: pageData.owner.value,
      active: isActive,
      title: pageData.title.value,
      description: pageData.description.value,
      metadataUri: pageData['metadata-uri']?.value.data || '',
      url: `https://${userAddressMainnet}.gated.so/#/${pageData.title?.data || tokenId}`,
      blockHeight: blockHeight
    };
  }

  setupMusicEventListeners() {
    setTimeout(() => {
      const songItems = document.querySelectorAll('.song-list li');
      const playPauseBtn = document.getElementById('play-pause-btn');
      const prevBtn = document.getElementById('prev-btn');
      const nextBtn = document.getElementById('next-btn');
      const cardHeader = document.querySelector('.card-header');
      const playlist = window.__albumPlaylistItem || musicData;

      // Use window.musicPlayer instead of creating new audio
      if (!window.musicPlayer) {
        console.error('Music player not initialized');
        return;
      }

      songItems.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          if (e.target.classList.contains('mint-track-btn')) return;

          // Use the main player methods
          const owned = !window.musicPlayer.isPreviewMode;
          window.musicPlayer.loadTrack(index, playlist, owned);
          window.musicPlayer.togglePlayPause();

          songItems.forEach(i => i.classList.remove('active-track'));
          item.classList.add('active-track');

          if (cardHeader) {
            cardHeader.style.backgroundImage = `url(${playlist.songs[index].imgUrl})`;
          }
        });
      });

      // Use main player methods for buttons
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => window.musicPlayer.togglePlayPause());
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => window.musicPlayer.previousTrack());
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => window.musicPlayer.nextTrack());
      }

      // Progress is driven by musicPlayer.updateProgress for preview vs full length
    }, 100);
  }

  getCurrentStxAddress() {
    if (!this.auth) {
      console.error('Auth not initialized');
      return null;
    }
    if (!this.auth.isSignedIn()) {
      console.error('User not signed in');
      return null;
    }
    return this.auth.getCurrentAddress();
  }

  setupWalletFunctions() {

    // Single source of truth efor wallet connection handling
    // Clear any existing connection state
    this._connecting = false;

    // Remove previous handlers if they exist
    if (window._connectWalletHandler) {
      delete window.connectWallet;
      delete window.disconnectWallet;
    }

    // Single source of truth for wallet connection
    const handleConnect = async (isChange = false) => {
      console.log('Connect handler called', { isChange });

      if (this._connecting) {
        console.log('Connection already in progress');
        return;
      }

      try {
        this._connecting = true;
        return await this.auth.connectWallet(isChange);
      } finally {
        this._connecting = false;
      }
    };

    // Set up global functions
    window._connectWalletHandler = true;
    window.connectWallet = handleConnect;
    window.disconnectWallet = () => this.auth.disconnectWallet();

    // Remove any existing click handlers
    const connectButton = document.getElementById('connectWallet-button');
    if (connectButton) {
      const newButton = connectButton.cloneNode(true);
      connectButton.parentNode.replaceChild(newButton, connectButton);

      // Add single click handler that uses our handleConnect function
      newButton.addEventListener('click', () => handleConnect(false));
    }
  }


  init() {


    // Now handle the initial route
    this.handleRoute();

    this.setupDeactivationHandlers();
  }

  initializePageState(toggle) {
    console.log('Step 2: Initializing settings page and toggle:', toggle.id);

    // Get the associated page card
    const pageCard = toggle.closest('.page-card');
    if (!pageCard) {
      console.warn('Page card not found for toggle:', toggle.id);
      return;
    }

    // Retrieve the save button and page data
    const saveBtn = pageCard.querySelector('.save-btn');
    if (!saveBtn || !saveBtn.dataset.page) {
      console.warn('Save button or page data missing for page card:', pageCard);
      return;
    }

    console.log('Raw page data before parsing:', saveBtn.dataset.page);

    try {
      const pageData = JSON.parse(saveBtn.dataset.page);
      console.log("Step 3: Getting Page data for edit page", pageData)

      // Check both festive mode and NFT from metadata
      const festiveMode = pageData?.metadata?.attributes?.find(
        attr => attr.trait_type === "Festive Mode" && attr.value === "On"
      );


      const festiveNFTData = {
        identifier: pageData?.metadata?.attributes?.find(
          attr => attr.trait_type === "Festive NFT"
        )?.value,
        metadata: pageData?.metadata?.properties?.meta?.content?.festive?.nft
      };

      console.log('Step 4: Getting Page-specific states:', { festiveMode, festiveNFTData });

      // Set toggle state based on metadata
      toggle.checked = festiveMode ? true : false;

      // If festive mode is enabled, initialize the UI

      console.log("Step 4.1: Confirming that according to Metadata, Festive Mode is ON");
      this.setupFestiveUI(pageCard, toggle, festiveNFTData);

      // Show/hide dropdown based on initial toggle state
      const dropdownContainer = pageCard.querySelector('.nft-dropdown-container');
      if (dropdownContainer) {
        dropdownContainer.style.display = toggle.checked ? 'block' : 'none';
      }

    } catch (error) {
      console.error('JSON Parse Error:', error);
      console.error('Attempted to parse:', saveBtn.dataset.page);
      return;
    }
  }

  initializeSettingsToggles() {
    document.querySelectorAll('.settings-cog').forEach(btn => {

      btn.addEventListener('click', e => {

        console.log("Step 1: Setting Cog Clicked")

        const toggle = e.target.closest('.page-card').querySelector('.festive-toggle');
        if (toggle) {
          this.initializePageState(toggle); // Initialize festive state when editing starts
        }

        const card = e.target.closest('.page-card');
        if (!card) return;

        const panel = card.querySelector('.settings-panel');
        if (!panel) return;

        // Close other open panels first
        document.querySelectorAll('.settings-panel:not(.none)').forEach(p => {
          if (p !== panel) p.classList.add('none');
        });

        panel.classList.toggle('none');

        // Reset form to original values if cancelling edit
        if (panel.classList.contains('none')) {
          this.resetFormToOriginal(card);
        }
      });
    });
  }

  setupFestiveUI(pageCard, toggle, festiveNFTData) {
    console.log('Step 5: Initializing UI for page card:', pageCard);

    console.log('Step 5.1: Creating the dropdown element');
    // Create the container structure
    let dropdownContainer = document.createElement('div');
    dropdownContainer.className = 'nft-dropdown-container';
    dropdownContainer.style.marginTop = '10px';
    dropdownContainer.style.display = toggle.checked ? 'block' : 'none';

    // Create loading indicator
    const loadingDiv = document.createElement('div');
    loadingDiv.textContent = 'Loading NFTs...';
    loadingDiv.className = 'loading-indicator';
    dropdownContainer.appendChild(loadingDiv);

    console.log('Step 5.2: Creating the select from dropdown element');
    // Create the select element
    const select = document.createElement('select');
    select.className = 'nft-select';
    select.style.display = 'none';  // Hide initially

    console.log('Step 5.3: Adding default option to dropdown');
    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select an NFT';
    select.appendChild(defaultOption);

    // If we have a current NFT, add it as selected
    console.log('Step 5.4: Setting current NFT as selected');
    if (festiveNFTData?.identifier) {
      const currentOption = document.createElement('option');
      currentOption.value = festiveNFTData.identifier;
      currentOption.textContent = `${festiveNFTData.metadata?.name || festiveNFTData.identifier.split('::')[1]} #${festiveNFTData.metadata?.imageUrl?.split('/').pop()?.replace('.png', '')}`;
      currentOption.dataset.imageUrl = festiveNFTData.metadata?.imageUrl;
      currentOption.selected = true;
      select.appendChild(currentOption);
    }

    console.log('Step 5.5: Adding everything to DOM');
    // Add the select to the container
    dropdownContainer.appendChild(select);

    // Add the dropdown to the DOM
    const settingsGroup = toggle.closest('.settings-group');
    if (settingsGroup) {
      // Remove any existing dropdown container first
      const existingContainer = settingsGroup.querySelector('.nft-dropdown-container');
      if (existingContainer) {
        existingContainer.remove();
      }
      settingsGroup.appendChild(dropdownContainer);
    }

    // Add toggle event listener
    toggle.addEventListener('change', (e) => {
      const isChecked = e.target.checked;
      dropdownContainer.style.display = isChecked ? 'block' : 'none';

      // If turning off, also remove the fall effect
      if (!isChecked && this.currentEffect) {
        document.body.removeChild(this.currentEffect.canvas);
        this.currentEffect = null;
      }
    });
    // Populate NFT options and handle loading state
    this.populateNFTOptions(dropdownContainer, festiveNFTData || {})
      .then(() => {
        // Remove loading indicator and show select
        loadingDiv.remove();
        select.style.display = 'block';
      })
      .catch(error => {
        console.error('Error populating NFTs:', error);
        loadingDiv.textContent = 'Error loading NFTs. Please try again.';
      });
  }

  checkImageLoads(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }

  async populateNFTOptions(dropdownContainer, festiveNFTData) {
    const select = dropdownContainer.querySelector('.nft-select');
    if (!select) return;
    console.log("Step 6: Populating dropdown with NFTs");

    try {
      const userSession = new UserSession();
      const userData = userSession.loadUserData();
      const userAddress = userData.profile.stxAddress.mainnet;
      console.log("Step 6.1: Grabbing user data", userSession, userData, userAddress);

      const nftData = await this.fetchNFTs(userAddress);
      console.log("Step 6.2: NFTs Found:", nftData);

      if (!nftData || !nftData.results) {
        throw new Error('No NFT data available');
      }

      // Clear existing options except the first (default) option
      const defaultOption = select.querySelector('option[value=""]');
      const currentOption = select.querySelector('option[selected]');
      select.innerHTML = '';
      if (defaultOption) select.appendChild(defaultOption);
      if (currentOption) select.appendChild(currentOption);

      console.log("Step 6.5: Creating preview section");
      // Create or find preview div
      const previewDiv = dropdownContainer.querySelector('.nft-preview') || document.createElement('div');
      previewDiv.className = 'nft-preview';
      previewDiv.style.marginTop = '10px';

      // Add preview div if it doesn't exist
      if (!dropdownContainer.querySelector('.nft-preview')) {
        dropdownContainer.appendChild(previewDiv);
      }

      // Show current NFT preview if it exists
      if (festiveNFTData?.metadata?.imageUrl) {
        if (await this.checkImageLoads(festiveNFTData.metadata.imageUrl)) {
          previewDiv.innerHTML = `
                    <img src="${festiveNFTData.metadata.imageUrl}" 
                        alt="Current NFT Preview" 
                        style="max-width: 100px; height: auto; border-radius: 4px;">
                `;
        }
      }

      console.log("Step 6.8: Loading NFTs that have valid images ONLY");
      // Add all NFTs
      for (const nft of nftData.results) {
        const nftIdentifier = nft.asset_identifier;
        const nftId = nft.value.repr.replace('u', ""); // Remove the 'u' prefix
        console.log("6.8a NFT Identifier", nftIdentifier)
        console.log("6.8b NftId", nftId)
        const [contractAddress, assetName] = nftIdentifier.split('::');

        console.log(`6.8c Processing NFT: ${assetName} #${nftId}`);

        try {
          // Correct URL structure for Hiro API
          const metadataUrl = `https://api.hiro.so/metadata/v1/nft/${contractAddress}/${nftId}`;
          const response = await fetch(metadataUrl);
          console.log('6.8d metadataUrl', metadataUrl)

          if (!response.ok) {
            console.log(`❌ Metadata fetch failed for ${assetName} #${nftId} with status ${response.status}`);
            continue;
          }

          const metadata = await response.json();
          const imageUrl = metadata.metadata.cached_thumbnail_image // Use the image URL from metadata
          console.log('6.8e metadata', metadata)
          console.log('6.8f imageUrl', metadata.metadata.cached_thumbnail_image)

          // If no image URL or image doesn't load, quietly skip
          if (!imageUrl || !(await this.checkImageLoads(imageUrl))) {
            console.log(`Skipping NFT ${assetName} #${nftId} - image not available`);
            continue;
          }




          const option = document.createElement('option');
          option.value = nftIdentifier;
          option.textContent = `${assetName} #${nftId}`;
          option.dataset.imageUrl = imageUrl;
          option.dataset.nftId = nftId;

          if (nftIdentifier === festiveNFTData?.identifier) {
            option.selected = true;
          }

          select.appendChild(option);

        } catch (error) {
          console.log(`Skipping NFT ${assetName} #${nftId} - error occurred`);
          continue;
        }
      }

      console.log("Step 6.9: Setting up change listener");
      // Add change event listener to select
      select.addEventListener('change', (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const imageUrl = selectedOption.dataset.imageUrl;

        if (imageUrl) {
          previewDiv.innerHTML = `
                    <img src="${imageUrl}" 
                        alt="NFT Preview" 
                        style="max-width: 100px; height: auto; border-radius: 4px;">
                `;

          // Update fall effect
          if (this.currentEffect) {
            document.body.removeChild(this.currentEffect.canvas);
            this.currentEffect = null;
          }
          this.currentEffect = initNFTFallEffect(imageUrl);
        } else {
          previewDiv.innerHTML = ''; // Clear preview if no image URL
        }
      });

    } catch (error) {
      console.error('Error populating NFT options:', error);
      throw error; // Propagate error to be handled by caller
    }
  }

  async findPageTransaction(cleanAddress, decodedTitle) {
    const limit = 50;
    let offset = 0;

    while (true) {
      console.log(`Searching transactions with offset: ${offset}`);
      const txResponse = await fetch(
        `https://stacks-node-api.mainnet.stacks.co/extended/v1/address/${cleanAddress}/transactions?limit=${limit}&offset=${offset}`
      );
      const txData = await txResponse.json();

      if (!txData.results || txData.results.length === 0) {
        console.log('No more transactions to search');
        break;
      }

      const pageTx = txData.results.find(tx => {
        const titleArg = tx.contract_call?.function_args?.[0]?.repr;


        // Remove quotes from blockchain title
        const cleanTitleArg = titleArg?.replace(/^"|"$/g, '');

        // console.log('Comparing:', {
        //   cleanTitleArg,
        //   decodedTitle,
        //   matches: cleanTitleArg === decodedTitle
        // });

        const normalizedTitleArg = titleArg?.toLowerCase().replace(/["\s-]/g, '');
        const normalizedSearchTitle = decodedTitle.toLowerCase().replace(/["\s-]/g, '');

        console.log('normalizedTitleArg', normalizedTitleArg)
        console.log('normalizedSearchTitle', normalizedTitleArg)

        return tx.contract_call?.function_name === 'mint-page' &&
          normalizedTitleArg === normalizedSearchTitle;
      });

      if (pageTx) {
        console.log('Found matching transaction at offset:', offset);
        return pageTx;
      }

      // If we got less than the limit, we've reached the end
      if (txData.results.length < limit) {
        console.log('Reached end of transactions');
        break;
      }

      offset += limit;
    }

    return null;
  }

  async fetchLinkPreview(url) {
    try {
      // Use the external API
      console.log('Fetching link preview for URL:', url);
      const response = await fetch(`https://favorited-link-preview.herokuapp.com/api/link-preview?url=${encodeURIComponent(url)}`);
      const data = await response.json();

      console.log('API success:', data.success);
      console.log('Has result object:', Boolean(data.result));

      // Added critical logging - extract these specifically
      if (data.result) {
        console.log('Site data found:', data);
        console.log('Description:', data.result.siteData?.description || '(no description)');
      } else {
        console.log('No siteData in the response');
      }


      // Check if there is a result object, even if there are errors
      if (!data.result) {
        console.error('API returned no result:', data.errors || 'Unknown error');
        throw new Error('Failed to fetch link preview');
      }

      // Get the result object directly
      const apiResult = data.result;
      const siteData = apiResult.siteData || {};

      console.log('Site data extracted:', siteData);
      console.log('Description from API:', siteData.description);

      // Determine the best image to use
      let bestImage = null;
      if (apiResult.topImage) {
        bestImage = apiResult.topImage;
      } else if (siteData.largestImage) {
        bestImage = siteData.largestImage;
      } else if (siteData.image) {
        bestImage = siteData.image;
      } else if (apiResult.imageResults && apiResult.imageResults.length > 0) {
        bestImage = apiResult.imageResults[0];
      }

      return {
        title: siteData.title || new URL(url).hostname,
        description: siteData.description,
        image: bestImage,
        favicon: siteData.favicon,
        siteName: siteData.siteName,
        url: url
      };
    } catch (error) {
      console.error('Error fetching link preview:', error);

      // Fallback to basic information when API fails
      let domain = '';
      try {
        domain = new URL(url).hostname.replace('www.', '');
      } catch (e) {
        domain = url;
      }

      return {
        title: domain.charAt(0).toUpperCase() + domain.slice(1),
        description: `Visit ${domain} to learn more.`,
        image: `https://www.google.com/s2/favicons?domain=${domain}&sz=128`,
        url: url
      };
    }
  }



  extractUrl = function (text) {
    if (!text) return [];
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const matches = text.match(urlRegex) || [];

    return matches.map(url => url.replace(/[.,)\]!?]+$/, ''));
  };


updatePageContent(page, actualOwnerAddress = null) {
  if (!this.authService) {
    this.authService = new AuthService(this);
    document.querySelector('.ownership-section')?.classList.add('loading');
  }

  const fetchLinkPreview = this.fetchLinkPreview || window.editsidebar?.fetchLinkPreview;

  if (!fetchLinkPreview) {
    console.error('fetchLinkPreview function not available');
  }

  const mainContent = document.getElementById('main-content');
  const { metadata } = page;

  // Debug the metadata structure
  console.log('Page metadata:', page.metadata);
  console.log('Content structure:', metadata?.properties?.meta?.content);
  console.log('Actual owner address passed:', actualOwnerAddress);

  const isDarkModeAttribute = page.metadata?.attributes?.find(attr =>
    attr.trait_type === 'Dark Mode' && attr.value === 'On'
  );
  const isDarkModeContent = page.metadata?.properties?.meta?.content?.darkMode === true;
  const shouldEnableDarkMode = isDarkModeAttribute || isDarkModeContent;

  console.log('Dark mode check:', {
    attributeValue: isDarkModeAttribute?.value,
    contentValue: isDarkModeContent,
    shouldEnable: shouldEnableDarkMode
  });

  if (shouldEnableDarkMode) {
    console.log('Enabling dark mode from metadata settings (page theme only, not persisted)');
    if (typeof initializeDarkModeToggle === 'function') {
      initializeDarkModeToggle(true, { persist: false });
    } else if (typeof applyPageTheme === 'function') {
      applyPageTheme(true);
    }
  } else {
    // If dark mode is not specified in metadata, initialize normally
    if (typeof initializeDarkModeToggle === 'function') {
      initializeDarkModeToggle(null); // Pass null to use localStorage
    }
  }
  // Check if ownership display is enabled (default to true if not specified)
  const ownershipEnabled = metadata?.properties?.meta?.content?.showOwnership !== false;
  console.log('Ownership enabled:', ownershipEnabled);

  // Debug logs for page info
  console.log('Current URL:', window.location.href);
  console.log('Page Title:', page.title);

  // Convert any IPFS URLs to HTTP URLs
  function convertIpfsToHttps(ipfsUri) {
    if (ipfsUri && ipfsUri.startsWith('ipfs://')) {
      const cid = ipfsUri.replace('ipfs://', '');
      return `https://ipfs.io/ipfs/${cid}`;
    }
    return ipfsUri;
  }

  const profilePhotoConfig = metadata?.properties?.meta?.content?.profilePhoto ?? null;
  console.log('👁️ metadata structure:', JSON.stringify(metadata, null, 2));

  // Get profile image - try from profilePhoto component first, then fall back to main image
  const profileImageUrl = profilePhotoConfig?.enabled && profilePhotoConfig?.src
    ? convertIpfsToHttps(profilePhotoConfig.src)
    : convertIpfsToHttps(metadata?.image) || 'https://your-default-image.jpg';

  console.log('Profile image URL:', profileImageUrl);

  // IMPORTANT: Use actualOwnerAddress for determining the owner's address
  // This ensures BNS pages use the resolved owner address, not the URL address
  const pageOwnerAddress = actualOwnerAddress || page.owner || this.authService.currentAddress;
  const cleanOwnerAddress = pageOwnerAddress ? pageOwnerAddress.toUpperCase() : '';
  
  console.log('Page owner address being used:', {
    actualOwnerAddress,
    pageOwner: page.owner,
    currentAddress: this.authService.currentAddress,
    finalOwnerAddress: pageOwnerAddress,
    cleanOwnerAddress
  });

  // Check for Mochines page - use the actual owner address
  const isMochinesPage = (
    // Check against the actual owner address instead of URL parsing
    (cleanOwnerAddress === 'SP1ZCYG0D3HCK2F7SY8VH9ZREB0JWCBSAPFNS8V5Z' ||
     cleanOwnerAddress === 'SP327AMYAAJFHDSDGE6AD0HTACYQ4CCXJGT47M2H3') &&
    (page.title === 'M.O.C.H.I.N.E.S' || page.title?.toLowerCase().replace(/[.\-\s]/g, '') === 'mochines')
  );

  console.log('Mochines page check:', {
    cleanOwnerAddress,
    pageTitle: page.title,
    isMochinesPage
  });

  // Generate NFT grid HTML (as in your original code)
  const nftContractsHTML = isMochinesPage
    ? Object.entries(MOCHINE_CONTRACTS)
      .map(([key, contract]) => `
        <div class="nft-preview" 
            data-name="${contract.name}" 
            data-contract-key="${key}">
          <img
            src="${contract.image}"
            alt="${contract.name}"
            class="nft-image"
            onerror="this.src='/api/placeholder/400/200'"
          >
        </div>
      `)
      .join('')
    : '';

  const contentBlocks = metadata?.properties?.meta?.content?.contentBlocks || [];
  const contentBlocksHTML = Array.isArray(contentBlocks)
    ? contentBlocks
      .sort((a, b) => a.order - b.order)
      .map(block => {
        const blockId = block.type === 'paragraph' ? `block-${Math.random().toString(36).substr(2, 9)}` : '';
        // Return the HTML for this block
        return `
      <div class="editable-block" data-type="${block.type}" ${blockId ? `id="${blockId}"` : ''}>
        ${block.type === 'heading'
            ? `<h2 class="editable">${block.content}</h2>`
            : `<p class="editable">${block.content}</p>`}
      </div>
    `;
      }).join('')
    : '';

  // Build the main container
  const containerHTML = `
  <div class="main-container">
    <h1 id="bnsv2NameDisplay" class="bns-name">${page.title}</h1>

    <div class="profile-section">
      <div id="profilePhoto">
        <img src="${profileImageUrl}" alt="Profile Image" class="profile-img">
      </div>
    </div>
    ${metadata?.properties?.meta?.content?.socialLinks?.enabled ? `
      <div class="social-links-section">
        ${Object.entries(metadata.properties.meta.content.socialLinks.links || {})
        .filter(([_, url]) => url)
        .map(([platform, url]) => {
          const icon = {
            x: 'fa-brands fa-x-twitter',
            discord: 'fa-brands fa-discord',
            website: 'fa-solid fa-globe'
          }[platform];
          return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="social-link">
                <i class="${icon}"></i>
              </a>`;
        }).join('')}
      </div>
    ` : ''}
    <div class="page-description">${page.description}</div>
    ${ownershipEnabled ? '<div class="ownership-section loading"><div class="loading-spinner">Verifying ownership...</div></div>' : '<!-- Ownership section hidden -->'}
    <div class="page-content">
      ${contentBlocksHTML}
      ${isMochinesPage ? `
        <div class="nft-collection-grid-container bg-gray-900 p-6 rounded-lg">
          <div class="nft-collection-grid">
            ${nftContractsHTML}
          </div>
        </div>
      ` : ''}
    </div>
  </div>
`;

  mainContent.innerHTML = containerHTML;

  // After inserting the HTML, process paragraphs for links
  if (this.fetchLinkPreview) {
    const self = this;

    // Define URL extraction if not already available

    // Find all paragraph blocks
    const paragraphBlocks = document.querySelectorAll('.editable-block[data-type="paragraph"]');

    paragraphBlocks.forEach((block, index) => {
      const paragraph = block.querySelector('p');
      if (paragraph) {
        const content = paragraph.textContent;
        const urls = self.extractUrl ? self.extractUrl(content) : extractUrl(content);

        if (urls && urls.length > 0) {
          const url = urls[0]; // Use the first URL found
          const blockId = block.id || `block-${index}`; // Define blockId here

          // If the block doesn't have an ID yet, add one
          if (!block.id) {
            block.id = blockId;
          }

          // Use your existing fetchLinkPreview function
          self.fetchLinkPreview(url).then(preview => {
            console.log('Preview data:', preview); // Debug the preview data

            // Create and append the link preview with the correct structure
            const previewElement = document.createElement('div');
            previewElement.className = 'external-link-preview';
            previewElement.setAttribute('data-for', blockId);
            previewElement.style.display = 'block';

            // Using the image from the preview data
            const imageHtml = preview.image
              ? `<img src="${preview.image}" class="preview-image" alt="${preview.title || 'Preview image'}" 
            onerror="this.style.display='none';">`
              : '';

            // Build the complete HTML structure to match your examples
            previewElement.innerHTML = `
        <div class="preview-card">
          <div class="preview-header">
            ${imageHtml || `<img src="${preview.favicon || `https://www.google.com/s2/favicons?domain=${new URL(url).hostname}&sz=128`}" 
              class="preview-favicon" 
              alt="${new URL(url).hostname} favicon" 
              onerror="this.onerror=null; this.src='https://www.google.com/s2/favicons?domain=${new URL(url).hostname}&sz=128';">`}
          </div>
          <div class="preview-content-wrapper">
            <div class="preview-content">
              <h3 class="preview-title">${preview.title || new URL(url).hostname}</h3>
              <p class="preview-description">${preview.description || `Visit ${new URL(url).hostname} to learn more.`}</p>
              <a href="${url}" target="_blank" rel="noopener noreferrer" class="preview-link-button">Visit Full Site</a>
            </div>
          </div>
        </div>
      `;

            // Insert the preview after the block
            block.parentNode.insertBefore(previewElement, block.nextSibling);
          }).catch(error => {
            console.error('Error fetching link preview:', error);
          });
        }
      }
    });
  }

  if (ownershipEnabled) {
    // IMPORTANT: Pass the actual owner address to updateOwnershipSection
    this.updateOwnershipSection(page, 0, cleanOwnerAddress);
  }

  // Update ownership section after DOM insertion - use the actual owner address
  const ownershipSection = document.querySelector('.ownership-section');

  if (ownershipSection && page.tx_id && cleanOwnerAddress) {
    ownershipSection.innerHTML = `
    <button onclick="window.open('https://explorer.hiro.so/txid/${page.tx_id}', '_blank', 'noopener,noreferrer')" 
      class="verify-button">
      <span class="verify-icon">✓</span>
      Owned by ${cleanOwnerAddress.slice(0, 4)}...${cleanOwnerAddress.slice(-4)}
    </button>
  `;
  }

  // IMPORTANT: Pass the actual owner address to initNFTInteractions
  if (typeof initNFTInteractions === 'function') {
    initNFTInteractions(this.authService, cleanOwnerAddress);
  }
}

  updateOwnershipSection(page, retryCount) {
    const maxRetries = 3;
    const ownershipSection = document.querySelector('.ownership-section');

    // Debugging
    console.log('Updating ownership section', {
      ownershipSectionExists: !!ownershipSection,
      page: page,
      pageId: page?.id,
      txId: page?.tx_id,
      retryCount
    });

    if (!ownershipSection) {
      console.error('Ownership section element not found');
      return;
    }

    // First, show a loading state
    ownershipSection.innerHTML = '<div class="loading-spinner"></div>';

    // Check if we have the page ID and transaction ID
    if (page?.id && page?.tx_id) {
      // For the specific contract you mentioned
      const contractAddress = 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5';
      const contractName = 'gated-pages';
      const tokenId = page.id;



      // Use fetchCallReadOnlyFunction
      fetchCallReadOnlyFunction({
        contractAddress,
        contractName,
        functionName: 'get-owner',
        functionArgs: [uintCV(tokenId)],
        network: 'mainnet'
      })
        .then(response => {
          // Parse the response to extract the owner address
          let ownerAddress = null;

          if (response && response.value && response.value.value) {
            // For a response like (ok (some SP...))
            ownerAddress = response.value.value.value;
          }

          if (ownerAddress) {
            const cleanAddress = ownerAddress.toUpperCase();
            ownershipSection.innerHTML = `
          <button onclick="window.open('https://explorer.hiro.so/txid/${page.tx_id}', '_blank', 'noopener,noreferrer')" 
            class="verify-button">
            <span class="verify-icon">✓</span>
            Owned by ${cleanAddress.slice(0, 4)}...${cleanAddress.slice(-4)}
          </button>
        `;
          } else {
            // No owner found
            ownershipSection.innerHTML = `
          <button onclick="window.open('https://explorer.hiro.so/txid/${page.tx_id}', '_blank', 'noopener,noreferrer')" 
            class="verify-button">
            <span class="verify-icon">✓</span>
             Owned by ${page.owner.slice(0, 4)}...${page.owner.slice(-4)}
          </button>
        `;
          }
          ownershipSection.classList.remove('loading');
        })
        .catch(error => {
          console.error('Error fetching owner from contract:', error);
          // Show fallback message on error
          ownershipSection.innerHTML = `
        <button onclick="window.open('https://explorer.hiro.so/txid/${page.tx_id}', '_blank', 'noopener,noreferrer')" 
          class="verify-button">
          <span class="verify-icon">✓</span>
      Owned by ${page.owner.slice(0, 4)}...${page.owner.slice(-4)}        </button>
      `;
          ownershipSection.classList.remove('loading');
        });
    } else if (page?.tx_id) {
      // If we don't have the page ID but have tx_id, show a simple verification button
      ownershipSection.innerHTML = `
      <button onclick="window.open('https://explorer.hiro.so/txid/${page.tx_id}', '_blank', 'noopener,noreferrer')" 
        class="verify-button">
        <span class="verify-icon">✓</span>
    Owned by ${page.owner.slice(0, 4)}...${page.owner.slice(-4)}
      </button>
    `;
      ownershipSection.classList.remove('loading');
    } else {
      // If we don't have transaction ID or page ID, retry or show fallback
      if (retryCount < maxRetries) {
        console.log(`Page data not ready, retrying (${retryCount + 1}/${maxRetries})...`);
        setTimeout(() => {
          this.updateOwnershipSection(page, retryCount + 1);
        }, 1000); // Retry after 1 second
      } else {
        // After max retries, show a fallback message
        ownershipSection.innerHTML = `
        <button class="verify-button disabled">
          <span class="verify-icon">?</span>
          Ownership unknown
        </button>
      `;
        ownershipSection.classList.remove('loading');
      }
    }
  }

// Enhanced BNS lookup that leverages your existing loadPages logic

async resolveBNSName(bnsName) {
  try {
    console.log('🔍 Resolving BNS name:', bnsName);
    
    const url = `https://api.hiro.so/v1/names/${bnsName}`;
    console.log('🌐 URL:', url);
    
       // Test if fetch is available
    console.log('🔧 typeof fetch:', typeof fetch);
    console.log('🔧 fetch available:', !!window.fetch);
    
    console.log('📡 About to make fetch request...');
    
    let response;
   try {
      response = await fetch(url);
      console.log('✅ Fetch completed successfully');
    } catch (fetchError) {
      console.error('❌ Fetch failed with error:', fetchError);
      console.error('❌ Fetch error type:', fetchError.constructor.name);
      console.error('❌ Fetch error message:', fetchError.message);
      throw new Error(`Fetch failed: ${fetchError.message}`);
    }

   console.log('📊 Response object:', response);
    console.log('📊 Response status:', response.status);
    console.log('📊 Response ok:', response.ok);
    console.log('📊 Response type:', response.type);
    console.log('📊 Response url:', response.url);
    if (!response.ok) {
      let errorText;
      try {
        errorText = await response.text();
        console.log('❌ Error response text:', errorText);
      } catch (textError) {
        console.error('❌ Could not read error response:', textError);
        errorText = 'Unknown error';
      }
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }
    
    console.log('📄 About to parse JSON...');
    let data;
    try {
      data = await response.json();
      console.log('✅ JSON parsed successfully');
    } catch (jsonError) {
      console.error('❌ JSON parsing failed:', jsonError);
      const responseText = await response.text();
      console.error('❌ Raw response text:', responseText);
      throw new Error(`JSON parsing failed: ${jsonError.message}`);
    }
    
    console.log('✅ JSON data:', data);
    console.log('📄 Data type:', typeof data);
    console.log('📄 Data keys:', Object.keys(data || {}));
    
    const address = data?.address;
    console.log('🎯 Extracted address:', address);
    
    if (!address) {
      console.warn('⚠️ No address found in response');
      console.log('📄 Full data structure:', JSON.stringify(data, null, 2));
      return null;
    }
    
    console.log('✅ BNS resolution successful:', address);
    return address;
    
  } catch (error) {
    console.error('❌ BNS resolution failed with error:', error);
    console.error('❌ Error type:', error.constructor.name);
    console.error('❌ Error message:', error.message);
    console.error('❌ Error stack:', error.stack);
    throw error;
  }
}


// Modified version of your loadPages that can optionally filter for a specific BNS
async loadPagesForBNS(stxAddress, targetBNSName = null) {
  try {
    const { pages } = await this.fetchNFTPages();
    console.log('Raw pages from blockchain:', pages);

    if (!pages?.length) {
      return null;
    }

    // Filter pages to ensure ownership
    const userOwnedPages = pages.filter(page =>
      page.owner?.toLowerCase() === stxAddress.toLowerCase()
    );
    
    console.log(`Pages owned by ${stxAddress}:`, userOwnedPages);

    if (!userOwnedPages.length) {
      console.warn(`No pages owned by ${stxAddress}`);
      return null;
    }

    // If we're looking for a specific BNS name, filter further
    let targetPages = userOwnedPages;
    if (targetBNSName) {
      targetPages = userOwnedPages.filter(page => {
        const pageBNSName = page.bns_name || page.metadata?.bns_name || page.metadata?.properties?.meta?.content?.bnsName;
        return pageBNSName === targetBNSName;
      });
      
      if (targetPages.length === 0) {
        console.warn(`No page found with BNS name: ${targetBNSName}`);
        return null;
      }
    }

    // Process pages with your existing strict contract type handling
    const processedPages = targetPages.map(page => {
      const pageContractType = page.contractType;
      if (!pageContractType) {
        console.error('Page missing contract type:', page);
        throw new Error(`Page ${page.id} is missing contract type`);
      }

      return {
        ...page,
        contractType: pageContractType
      };
    });

    console.log('Processed pages:', processedPages.map(p => ({
      id: p.id,
      contractType: p.contractType,
      title: p.title
    })));

    return targetBNSName ? processedPages[0] : processedPages; // Return single page for BNS lookup, array for dashboard

  } catch (error) {
    console.error('Error loading pages:', error);
    throw error;
  }
}

// Update your existing loadPages method to use the new logic
async loadPages(stxAddress) {
  const pagesList = document.getElementById('pages-list');

  // Replace loading text with skeleton loader
  pagesList.innerHTML = this.getSkeletonLoader();

  try {
    const processedPages = await this.loadPagesForBNS(stxAddress);
    
    if (!processedPages || !processedPages.length) {
      pagesList.innerHTML = this.getEmptyState();
      return;
    }

    pagesList.innerHTML = `
        <div class="dashboard-view">
            ${processedPages.map(page => this.renderPageCard(page)).join('')}
        </div>
        <div class="page-edit-panel none"></div>
    `;

    this.initializePageHandlers();

    // Initialize counters for each page
    processedPages.forEach(page => {
      this.initializeCharCounters(page);
    });

  } catch (error) {
    console.error('Error loading pages:', error);
    pagesList.innerHTML = this.getErrorState(stxAddress);
  }
}

  initializeRouteHandlers() {
    const validateNFTImageUrl = async (url) => {
      try {
        const response = await fetch(url, { method: 'HEAD' });
        return response.ok;
      } catch (error) {
        console.error('Error validating NFT image URL:', error);
        return false;
      }
    };

    const cleanupNFTEffect = () => {
      if (window.currentNFTFallEffect) {
        try {
          document.body.removeChild(window.currentNFTFallEffect.canvas);
          window.currentNFTFallEffect = null;
          console.log('NFT Fall Effect cleaned up successfully');
        } catch (error) {
          console.error('Error cleaning up NFT Fall Effect:', error);
        }
      }
    };

    this.routeHandlers = {
      publicAlbum: {
        match: (parsedUrl) => Boolean(parsedUrl.pathAlbum),
        render: async (stxAddress, pageTitle, routerInstance) => {
          const { creator, slug } = routerInstance._lastParsedUrl?.pathAlbum || {};
          await renderPublicAlbumPage(routerInstance, creator, slug);
        }
      },
      home: {
        match: (parsedUrl) => {
          // Only match home if user is NOT signed in
          const isSignedIn = this.auth?.isSignedIn();
          const matches = !parsedUrl.stxAddress && !parsedUrl.pageTitle && !isSignedIn;
          console.log('Home match check:', {

            hasStxAddress: this.auth?.currentAddress,
            hasPageTitle: !!parsedUrl.pageTitle,
            isSignedIn,
            matches
          });
          return matches;
        },
        render: () => this.renderHomePage()
      },
      // Update these two route handlers in your routeHandlers object

      dashboard: {
        match: (parsedUrl) => {
          // Get all possible address values for comparison
          const routerStxAddress = this.currentStxAddress?.toLowerCase();
          const windowStxAddress = window.stxAddress?.toLowerCase();
          const parsedAddress = parsedUrl.stxAddress?.toLowerCase();
          const currentStx = this.auth.currentAddress;



          console.log("currentSTX", currentStx);



          const noPageTitle = !parsedUrl.pageTitle;

          const isSignedIn = this.auth?.isSignedIn() ||
            this.auth?.userSession?.isUserSignedIn() ||
            localStorage.getItem('isAuthenticated') === 'true';

          console.log('Dashboard match check:', {
            noPageTitle,
            isSignedIn,
            currentStx: this.auth.currentAddress,
            localStorageStx: localStorage.getItem('authAddress')
          });

          // Show dashboard when address matches AND user is signed in AND there's no page title
          return isSignedIn && noPageTitle;
        },
        render: (currentStx) => this.renderAdminDashboard(this.auth.currentAddress)
      },

      claim: {
        match: (parsedUrl) => {
          // Get all possible address values for comparison
          const routerStxAddress = this.currentStxAddress?.toLowerCase();
          const windowStxAddress = window.stxAddress?.toLowerCase();
          const localStorageAddress = localStorage.getItem('authAddress')?.toLowerCase();
          const parsedAddress = parsedUrl.stxAddress?.toLowerCase();

          // Check if the URL address matches ANY of the user's addresses
          const addressMatches =
            (routerStxAddress && parsedAddress === routerStxAddress) ||
            (windowStxAddress && parsedAddress === windowStxAddress) ||
            (localStorageAddress && parsedAddress === localStorageAddress);

          const noPageTitle = !parsedUrl.pageTitle;
          const isSignedIn = this.auth?.isSignedIn() ||
            this.auth?.userSession?.isUserSignedIn() ||
            localStorage.getItem('isAuthenticated') === 'true';

          console.log('Claim match check:', {
            addressMatches,
            noPageTitle,
            isSignedIn,
            currentStx: this.currentStxAddress,
            windowStx: window.stxAddress,
            localStorageStx: localStorage.getItem('authAddress'),
            parsedStx: parsedUrl.stxAddress
          });

          // Changed logic: If user is looking at their own address but isn't signed in,
          // don't match this route (so they'll go to home instead)
          // Only match for viewing other people's addresses
          return parsedUrl.stxAddress && noPageTitle && !addressMatches;
        },
        render: (stxAddress) => this.renderClaimPage(stxAddress)
      },
      specificPage: {
        match: (parsedUrl) => {
          const isSpecificPage = parsedUrl.pageTitle?.toLowerCase() === 'when-walls-break';
          const allowedHosts = [
            'spmymhhc95ye7ezef19nnwszmhxej97zyhjb5nxv.localhost',
            'sp3v0kzbgk20cmee74ky0j0h0mhysgwvarekwmcpq.localhost',
            'sp3v0kzbgk20cmee74ky0j0h0mhysgwvarekwmcpq.gated.so',
            'blocktune.gated.so'
          ];
          const currentHost = window.location.hostname;
          const isAllowedHost = allowedHosts.includes(currentHost);

          return isSpecificPage && isAllowedHost;
        },
        render: async (stxAddress, pageTitle) => {
          // Show loader immediately
          loader.show();

          try {
            // Update loader text for different stages
            loader.updateText('Loading album metadata...');
            console.log("Album Metadata:", JSON.stringify(albumMetadata, null, 2));

            loader.updateText('Initializing music player...');
            // With this:
            if (!window.musicPlayer?.isInitialized) {
              // Create a proper instance of the music player
              window.musicPlayer = Object.create(musicPlayer);

              // Initialize audio player first
              window.musicPlayer.audioPlayer = new Audio();  // Add this line

              // Handle both preview time limit and track ending
              window.musicPlayer.audioPlayer.addEventListener('timeupdate', () => {
                if (window.musicPlayer.isPreviewMode &&
                  window.musicPlayer.audioPlayer.currentTime >= window.musicPlayer.MAX_PLAY_TIME) {
                  // When preview time limit is reached, move to next track
                  const nextIndex = (window.musicPlayer.currentTrackIndex + 1) % musicData.songs.length;
                  window.musicPlayer.setCurrentTrack(nextIndex);
                  window.musicPlayer.loadTrack(nextIndex, musicData);

                  // Auto-play next track
                  const playPromise = window.musicPlayer.audioPlayer.play();
                  if (playPromise) {
                    playPromise
                      .then(() => {
                        window.musicPlayer.startAudioTimer();
                        window.musicPlayer.startCountdown();
                        window.musicPlayer.updatePlayPauseButtons(true);
                      })
                      .catch(error => {
                        console.warn('Auto-play prevented:', error);
                        window.musicPlayer.updatePlayPauseButtons(false);
                      });
                  }
                }
              });

              // Add auto-play event listener before initialization
              window.musicPlayer.audioPlayer.addEventListener('ended', () => {
                const nextIndex = (window.musicPlayer.currentTrackIndex + 1) % musicData.songs.length;
                window.musicPlayer.setCurrentTrack(nextIndex);
                window.musicPlayer.loadTrack(nextIndex, musicData);

                // Auto-play with error handling
                const playPromise = window.musicPlayer.audioPlayer.play();
                if (playPromise) {
                  playPromise
                    .then(() => {
                      if (window.musicPlayer.isPreviewMode) {
                        window.musicPlayer.startAudioTimer();
                        window.musicPlayer.startCountdown();
                      }
                      window.musicPlayer.updatePlayPauseButtons(true);
                    })
                    .catch(error => {
                      console.warn('Auto-play prevented:', error);
                      window.musicPlayer.updatePlayPauseButtons(false);
                    });
                }
              });

              // Initialize after adding event listener
              window.musicPlayer.init();
            }

            loader.updateText('Preparing content...');
            // In your page render function
            this.mainContent.innerHTML = `
  <div id="page-container">
    <div class="profile-section">
      <!-- Maintain the exact DOM structure the ProfilePhoto component expects -->
      <div id="profileOuterContainer" class="profile-outer-container">
        <div id="profileInnerContainer" class="profile-inner-container">
          <div id="profilePhoto" class="profile-photo">
            <img src="https://images.gamma.io/cdn-cgi/image/quality=100,width=300,height=300/https://images.gamma.io/ipfs/QmXFcWnqAiCnkx23riPZH8Tm6YX3MQkB9yeMNQ8tQENGoj" alt="Profile" class="logo" style="width:60px;" />
            <div id="tipText" class="tip-text">Tip 1 STX</div>
          </div>
        </div>
      </div>
      <audio id="clickSound" src="https://www.soundjay.com/buttons/sounds/button-50.mp3" preload="auto"></audio>
      
      <!-- Other elements -->
      <div id="bnsv2NameDisplay" class="bns-name">Zero to Clarity</div>
      <div class="page-description" style="color: rgb(125, 125, 125);">Clarity Lessons for beginners</div>

      <div class="page-content content-editable-area"></div>
    </div>
  </div>
`;
            // Add your existing style additions
            const style = document.createElement('style');
            style.textContent = `
        .profile-outer-container {
          transform-origin: center;
          transition: transform 0.1s ease;
        }
      `;
            document.head.appendChild(style);

            loader.updateText('Loading When Walls Break...');
            const nftIntegration = {
              ...NFTAudioIntegration,
              auth: window.auth
            };

            const nftAvailability = await nftIntegration.initialize();
            console.log('NFT Availability:', nftAvailability);

            setTimeout(() => {
              try {
                if (!window.profilePhoto) {
                  window.profilePhoto = new ProfilePhoto();
                }
              } catch (error) {
                console.error('Error rendering specific page:', error);
              }
            }, 0);

            renderStoreItems([musicData], nftAvailability);
            this.setupMusicEventListeners();
            loader.hide();

          } catch (error) {
            console.error('Error rendering specific page:', error);
            this.mainContent.innerHTML = `
        <div class="error-message">
          Failed to load content. Please try again later.
        </div>
      `;

          }
        }
      },
page: {
  match: (parsedUrl) => {
    try {
      const { stxAddress, pageTitle } = parsedUrl;

      const isBNS = typeof pageTitle === 'string' && pageTitle.endsWith('.btc');
      const hasTitle = Boolean(pageTitle);
      const isNotExcluded = pageTitle !== 'riseofthememe' && pageTitle !== 'when-walls-break';

      console.log('🔍 Page route match checking:', {
        stxAddress,
        pageTitle,
        isBNS,
        hasTitle,
        isNotExcluded
      });

      return hasTitle && isNotExcluded;
    } catch (error) {
      console.error('⚠️ Error in page route match:', error);
      return false;
    }
  },

  render: async (stxAddress, pageTitle, routerInstance) => {
    cleanupNFTEffect();
    loader.show();
    
    try {
      const isBNS = pageTitle && pageTitle.endsWith('.btc');
      
      // For BNS routes, stxAddress might be null - handle this gracefully
      const cleanAddress = stxAddress ? stxAddress.toUpperCase() : null;
      const searchTitle = decodeURIComponent(pageTitle).replace(/-/g, ' ');
      
      console.log('🔍 Page render starting:', {
        stxAddress: cleanAddress,
        pageTitle,
        searchTitle,
        isBNS
      });

      let matchingPage = null;

      if (isBNS) {
        // Handle BNS lookup
        console.log('🔗 BNS lookup detected for:', pageTitle);
        
        try {
          console.log('⏳ About to resolve BNS...');
          const bnsOwnerAddress = await routerInstance.resolveBNSName(pageTitle);
          console.log('✅ BNS resolution completed:', bnsOwnerAddress);
          
          if (!bnsOwnerAddress) {
            throw new Error(`Could not resolve BNS name: ${pageTitle}`);
          }
          
          console.log('📍 BNS resolved to address:', bnsOwnerAddress);
          
          // Get all pages owned by the BNS owner
          console.log('🔍 Fetching pages for BNS owner...');
          const { pages } = await routerInstance.fetchNFTPages(bnsOwnerAddress);
          console.log('📊 Found pages:', pages?.length);
          
          // Now we need to fetch metadata for each page to check for BNS name
          console.log('🔍 Checking each page for BNS name match...');
          
          for (const page of pages) {
            console.log(`📄 Checking page ${page.id}: "${page.title}"`);
            
            try {
              // Fetch metadata for this page
              const metadata = await routerInstance.fetchPageMetadata(page.id);
              console.log(`📊 Metadata loaded for page ${page.id}`);
              
              // Add metadata to the page object
              page.metadata = metadata;
              
              // Check for BNS name in various locations
              let pageBNSName = page.bns_name || 
                               metadata?.bns_name || 
                               metadata?.properties?.meta?.content?.bnsName;
              
              // IMPORTANT: Also check in attributes array for BNS name
              if (!pageBNSName && metadata?.attributes) {
                const bnsAttribute = metadata.attributes.find(attr => 
                  attr.trait_type === 'BNS Name' && attr.value
                );
                if (bnsAttribute) {
                  pageBNSName = bnsAttribute.value;
                  console.log(`🎯 Found BNS name in attributes: "${pageBNSName}"`);
                }
              }
              
              console.log(`🔍 Page ${page.id} BNS name: "${pageBNSName}"`);
              console.log(`🎯 Looking for: "${pageTitle}"`);
              
              // If this page matches the BNS name we're looking for
              if (pageBNSName === pageTitle) {
                console.log(`✅ Found matching page: ${page.id} with BNS name: ${pageBNSName}`);
                matchingPage = page;
                break; // Exit the loop once we find a match
              }
              
            } catch (metadataError) {
              console.warn(`⚠️ Could not fetch metadata for page ${page.id}:`, metadataError);
              // Continue to next page if metadata fetch fails
              continue;
            }
          }
          
          if (!matchingPage) {
            console.log('❌ No matching page found');
            console.log('📋 Available pages summary:');
            
            // Log what we found for debugging
            for (const page of pages) {
              const pageBNSName = page.bns_name || 
                                 page.metadata?.bns_name || 
                                 page.metadata?.properties?.meta?.content?.bnsName ||
                                 'No BNS name found';
              console.log(`  - Page ${page.id}: "${page.title}" - BNS: "${pageBNSName}"`);
            }
            
            // ADD TOKEN URI CALLS FOR EACH PAGE
            console.log('🔍 === DEBUGGING: Calling get-token-uri for each page ===');
            for (const page of pages) {
              try {
                console.log(`📄 Fetching token URI for page ${page.id}...`);
                const metadata = await routerInstance.fetchPageMetadata(page.id);
                console.log(`✅ Token URI metadata for page ${page.id}:`, metadata);
                
                // Look for BNS name in the metadata
                if (metadata) {
                  console.log(`🔍 Searching for BNS name in metadata for page ${page.id}:`);
                  console.log(`   - metadata.bns_name: "${metadata.bns_name || 'not found'}"`);
                  console.log(`   - metadata.properties?.meta?.content?.bnsName: "${metadata.properties?.meta?.content?.bnsName || 'not found'}"`);
                  console.log(`   - metadata.attributes (if any):`, metadata.attributes);
                  console.log(`   - metadata.properties (full):`, metadata.properties);
                  
                  // Check if any field contains our BNS name
                  const metadataString = JSON.stringify(metadata).toLowerCase();
                  const searchBNS = pageTitle.toLowerCase();
                  const containsBNS = metadataString.includes(searchBNS.replace('.btc', ''));
                  
                  console.log(`   - Does metadata contain "${searchBNS}"? ${containsBNS}`);
                  if (containsBNS) {
                    console.log(`   🎯 FOUND BNS NAME IN METADATA FOR PAGE ${page.id}!`);
                  }
                }
                
              } catch (metadataError) {
                console.error(`❌ Error fetching token URI for page ${page.id}:`, metadataError);
              }
            }
            
            // ADD TRANSACTION LOGGING HERE
            console.log('🔍 === DEBUGGING: Recent contract transactions ===');
            try {
              const contractAddress = 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5';
              const response = await fetch(`https://api.mainnet.hiro.so/extended/v1/address/${contractAddress}/transactions?limit=10`);
              const data = await response.json();
              
              console.log('📊 Recent 10 transactions from contract:');
              data.results?.forEach((tx, index) => {
                console.log(`${index + 1}. TX: ${tx.tx_id}`);
                console.log(`   Function: ${tx.contract_call?.function_name || 'N/A'}`);
                console.log(`   Sender: ${tx.sender_address}`);
                console.log(`   Block: ${tx.block_height}`);
                
                // Log function arguments if available
                if (tx.contract_call?.function_args) {
                  console.log('   Arguments:');
                  tx.contract_call.function_args.forEach(arg => {
                    console.log(`     ${arg.name}: ${arg.repr}`);
                  });
                }
                console.log('   ---');
              });
            } catch (txError) {
              console.error('❌ Error fetching transactions:', txError);
            }
            
            throw new Error(`No page found for BNS name: ${pageTitle}`);
          }
          
          console.log('✅ Found BNS page:', matchingPage);
          
        } catch (error) {
          console.error('❌ BNS lookup failed:', error);
          routerInstance.mainContent.innerHTML = `
            <div class="error-container">
              <h2>BNS Page Not Found</h2>
              <p>Could not find a page for <strong>${pageTitle}</strong></p>
              <p class="error-detail">${error.message}</p>
            </div>
          `;
          return; // Important: return here to stop execution
        }
        
      } else {
        // Handle regular page title lookup
        console.log('📄 Regular page lookup for:', searchTitle);
        
        // For regular pages, we need a valid stxAddress
        if (!cleanAddress) {
          console.error('❌ No STX address provided for regular page lookup');
          routerInstance.mainContent.innerHTML = `
            <div class="error-container">
              <h2>Invalid Request</h2>
              <p>No STX address provided for page lookup</p>
            </div>
          `;
          return;
        }
        
        // Check if this is the MOCHINES page
        const isMochinesPage = (
          pageTitle === 'm-o-c-h-i-n-e-s' &&
          (cleanAddress === 'SP1ZCYG0D3HCK2F7SY8VH9ZREB0JWCBSAPFNS8V5Z' ||
            cleanAddress === 'SP327AMYAAJFHDSDGE6AD0HTACYQ4CCXJGT47M2H3')
        );

        console.log('isMochinesPage', isMochinesPage);
        
        // Force dark mode for MOCHINES page (page-only, not persisted)
        if (isMochinesPage && typeof applyPageTheme === 'function') {
          applyPageTheme(true);
        }

        // Fetch page data from smart contract using the provided stxAddress
        const { pages } = await routerInstance.fetchNFTPages(cleanAddress);
        matchingPage = pages.find(p => {
          const normalizedPageTitle = p.title?.toLowerCase().replace(/[.\-\s]/g, '');
          const normalizedSearchTitle = searchTitle.toLowerCase().replace(/[.\-\s]/g, '');
          console.log('Comparing:', normalizedPageTitle, 'with', normalizedSearchTitle);
          return normalizedPageTitle === normalizedSearchTitle;
        });
        
        console.log('Matching page:', matchingPage);
      }

      // Rest of your existing logic for handling the found page
      if (matchingPage) {
        console.log('🎯 Processing found page...');
        
        // For BNS pages, metadata is already loaded; for regular pages, fetch it
        if (!isBNS || !matchingPage.metadata) {
          const metadata = await routerInstance.fetchPageMetadata(matchingPage.id);
          matchingPage.metadata = metadata;
        }

        // For regular (non-BNS) pages, prefetch adjacent pages
        if (!isBNS && cleanAddress) {
          const { pages } = await routerInstance.fetchNFTPages(cleanAddress);
          const currentIndex = pages.findIndex(p => p.id === matchingPage.id);
          if (currentIndex > 0) {
            routerInstance.prefetchMetadata(pages[currentIndex - 1].id);
          }
          if (currentIndex < pages.length - 1) {
            routerInstance.prefetchMetadata(pages[currentIndex + 1].id);
          }
        }

        // Render the page
        routerInstance.mainContent.innerHTML = `<!-- Page content will be populated by updatePageContent -->`;
        routerInstance.updatePageContent(matchingPage);

        // Debug profile photo loading
        setTimeout(() => {
          const profilePhoto = document.getElementById('profilePhoto');
          console.log('Profile photo element:', profilePhoto);
          if (profilePhoto) {
            console.log('Profile photo HTML:', profilePhoto.innerHTML);
          }
        }, 1000);

        // Initialize edit sidebar
        setTimeout(async () => {
          window.editSidebar = new EditSidebar(routerInstance);
          // For BNS pages, use the actual owner's address, not the URL address
          const ownerAddress = isBNS ? matchingPage.owner : cleanAddress;
          await window.editSidebar.updateVisibility(matchingPage, ownerAddress);
        }, 1000);

      } else {
        // No matching page found
        const errorMessage = isBNS 
          ? `No page found for BNS name: ${pageTitle}`
          : `No page found with title: ${searchTitle}`;
          
        routerInstance.mainContent.innerHTML = `
          <div class="error-container">
            <h2>Page Not Found</h2>
            <p>${errorMessage}</p>
            ${isBNS ? `
              <div class="bns-info">
                <p>This BNS name may not have an associated page yet.</p>
                <p>BNS names must be linked to pages by their owners.</p>
              </div>
            ` : ''}
          </div>
        `;
      }

    } catch (error) {
      console.error('❌ Page render error:', error);
      console.error('❌ Error details:', {
        message: error.message,
        stack: error.stack,
        stxAddress,
        pageTitle,
        isBNS: pageTitle && pageTitle.endsWith('.btc')
      });
      
      routerInstance.mainContent.innerHTML = `
        <div class="error-container">
          <h2>Error Loading Page</h2>
          <p>${error.message || 'Something went wrong.'}</p>
          <details>
            <summary>Technical Details</summary>
            <pre>stxAddress: ${stxAddress}
pageTitle: ${pageTitle}
isBNS: ${pageTitle && pageTitle.endsWith('.btc')}

${error.stack || error.toString()}</pre>
          </details>
        </div>
      `;
    } finally {
      loader.hide();
    }
  }
},
      riseofthememe: {
        match: (parsedUrl) => {
          return parsedUrl.pageTitle === 'riseofthememe';
        }
      }
    }
  }

  // Updated fetchPageMetadata with caching and multiple gateways
  async fetchPageMetadata(tokenId) {
    console.log('🔍 Attempting to fetch metadata for token ID:', tokenId);

    // Check cache first
    const cacheKey = `gated-pages-${tokenId}`;
    if (metadataCache.has(cacheKey)) {
      console.log('Cache hit for token ID:', tokenId);
      return metadataCache.get(cacheKey);
    }

    const tokenUriOptions = {
      contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
      contractName: 'gated-pages',
      functionName: 'get-token-uri',
      functionArgs: [uintCV(tokenId)],
      network: STACKS_MAINNET,
      senderAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5'
    };

    try {
      const tokenUriResult = await fetchCallReadOnlyFunction(tokenUriOptions);
      console.log('Token URI Result for ID', tokenId, ':', tokenUriResult);

      if (tokenUriResult?.value?.value?.value) {
        const ipfsUri = tokenUriResult.value.value.value;
        const cid = ipfsUri.replace('ipfs://', '');

        // Race multiple gateways for fastest response
        const fetchPromises = ipfsGateways.map(gateway => {
          const url = `${gateway}${cid}`;
          return fetch(url)
            .then(response => {
              if (!response.ok) {
                throw new Error(`Gateway ${gateway} failed with status: ${response.status}`);
              }
              return response.json();
            })
            .catch(error => {
              console.warn(`Gateway ${gateway} failed:`, error);
              return Promise.reject(error);
            });
        });

        try {
          // Use the fastest responding gateway
          const metadata = await Promise.any(fetchPromises);

          // Cache the result
          metadataCache.set(cacheKey, metadata);

          // Save to localStorage
          try {
            const cacheObj = {
              timestamp: Date.now(),
              data: Object.fromEntries(metadataCache)
            };
            localStorage.setItem('metadataCache', JSON.stringify(cacheObj));
          } catch (e) {
            console.error('Failed to save cache to localStorage:', e);
          }

          console.log('Metadata for token', tokenId, ':', metadata);
          return metadata;
        } catch (error) {
          console.error('All gateways failed:', error);

          // Fallback to original method if all gateways fail
          const httpUrl = ipfsUri.replace('ipfs://', 'https://ipfs.io/ipfs/');
          const metadataResponse = await fetch(httpUrl);
          if (!metadataResponse.ok) {
            throw new Error('Failed to fetch metadata');
          }

          const metadata = await metadataResponse.json();

          // Cache even the fallback result
          metadataCache.set(cacheKey, metadata);
          console.log('Metadata for token', tokenId, ':', metadata);
          return metadata;
        }
      }
    } catch (error) {
      console.error('Error fetching metadata for token', tokenId, ':', error);
      return null;
    }
  }

  // Add the prefetch method
  prefetchMetadata(tokenId) {
    const cacheKey = `gated-pages-${tokenId}`;
    if (metadataCache.has(cacheKey)) return;

    // Start fetching but don't await
    this.fetchPageMetadata(tokenId).catch(err =>
      console.error('Prefetch failed for', tokenId, err)
    );
  }


  initialize() {
    this.initializePageHandlers();
    this.setupGlobalErrorHandler();
  }

  initializePageHandlers() {
    // Unbind existing handlers to prevent memory leaks
    this.removeExistingHandlers();

    // Initialize all handlers
    this.initializeSettingsToggles();
    this.initializeSaveButtons();
    this.initializeCancelButtons();
  }

  removeExistingHandlers() {
    document.querySelectorAll('.settings-cog, .save-btn, .cancel-btn, .toggle-status')
      .forEach(element => {
        const clone = element.cloneNode(true);
        element.parentNode.replaceChild(clone, element);
      });
  }

  initializeSaveButtons() {
    document.querySelectorAll('.save-btn').forEach(btn => {
      btn.addEventListener('click', async e => {
        try {
          const button = e.target;
          if (this.pendingUpdates.has(button)) return;

          this.pendingUpdates.add(button);
          button.disabled = true;
          button.textContent = 'Submitting...';

          if (this.currentEffect) {
            document.body.removeChild(this.currentEffect.canvas);
            this.currentEffect = null;
          }

          const panel = button.closest('.settings-panel');
          const pageData = this.getPageDataFromPanel(panel);

          if (!this.validatePageData(pageData)) {
            throw new Error('Invalid page data');
          }

          // Submit transaction
          await this.updatePage(pageData);

        } catch (error) {
          this.handleError('Failed to submit update', error);
        } finally {
          const button = e.target;
          button.textContent = 'Update Page';
          button.disabled = false;
          this.pendingUpdates.delete(e.target);
        }
      });
    });
  }

  getPageDataFromPanel(panel) {
    console.log("Step 7: Collecting and Sending data from Settings Page to Confirmation Page")

    const titleInput = panel.querySelector('input[type="text"]');
    const descriptionInput = panel.querySelector('textarea');
    const saveBtn = panel.querySelector('.save-btn');
    const pageCard = panel.closest('.page-card');

    // Get contract type from the dedicated data attribute
    const contractType = saveBtn.dataset.contractType;
    if (!titleInput || !descriptionInput || !saveBtn || !pageCard) {
      throw new Error('Missing required form elements');
    }

    let id = null;
    try {
      const partialData = saveBtn.dataset.page;
      const idMatch = partialData.match(/"id":(\d+)/);
      if (idMatch) {
        id = parseInt(idMatch[1], 10);
      }
    } catch (error) {
      console.error('Error extracting ID:', error);
    }

    // Get festive mode state and NFT details
    const festiveToggle = pageCard.querySelector('.festive-toggle');
    let festiveData = {};

    if (festiveToggle && festiveToggle.checked) {
      const dropdownContainer = pageCard.querySelector('.nft-dropdown-container');
      const select = dropdownContainer?.querySelector('.nft-select');

      if (select && select.selectedIndex > 0) {
        const selectedOption = select.options[select.selectedIndex];
        festiveData = {
          festiveMode: true,
          festiveNFT: {
            identifier: selectedOption.value,
            name: selectedOption.textContent,
            imageUrl: selectedOption.dataset.imageUrl,
            nftId: selectedOption.dataset.nftId
          }
        };
      }
    }

    const pageData = {
      id: id,
      contractType: contractType, // Use the separate data attribute
      title: titleInput.value.trim(),
      description: descriptionInput.value.trim(),
      active: true,
      slug: this.generateSlug(titleInput.value),
      ...festiveData  // Include festive data if it exists

    };

    console.log('Step 7.1: Assembled page data:', pageData);
    return pageData;
  }

  async updatePage(pageData) {
    console.log("Step 7.2: Validate and initiates the confirmation process")

    if (!this.currentStxAddress) {
      throw new Error('No wallet connected');
    }

    try {
      // First show confirmation modal
      await this.showUpdateConfirmation(
        pageData.id,
        pageData.title,
        pageData.description,
        pageData.slug || this.sanitizeUrl(pageData.title),
        this.currentStxAddress,
        pageData.active,
        pageData.contractType
      );
    } catch (error) {
      console.error('Error in update flow:', error);
      throw error;
    }
  }

  showNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => notification.remove(), 5000);
  }

  validatePageData(pageData) {
    const { title, description } = pageData;

    if (!title || title.length > 64) return false;
    if (!description || description.length > 256) return false;

    // Check for valid characters in title (matches smart contract requirements)
    const validTitleRegex = /^[a-zA-Z0-9-]+$/;
    return validTitleRegex.test(this.generateSlug(title));
  }

  generateSlug(title) {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  updateUIAfterSave(card, pageData) {
    if (!card) {
      console.warn('No card element found');
      return;
    }
    console.log('Updating UI with page data:', pageData);

    // Store the data on both the card and the save button
    const safePageData = {
      id: pageData.id,
      contractType: pageData.contractType,
      title: String(pageData.title || '').trim(),
      description: String(pageData.description || '').trim(),
      active: true,
      slug: pageData.slug || ''
    };

    // Store data on the card itself
    try {
      card.dataset.page = JSON.stringify(safePageData);
    } catch (error) {
      console.error('Failed to save data to card:', error);
    }


    const saveBtn = card.querySelector('.save-btn');
    if (saveBtn) {
      // Store contract type separately
      saveBtn.dataset.contractType = pageData.contractType;

      const safePageData = {
        id: pageData.id,
        title: String(pageData.title || '').trim(),
        description: String(pageData.description || '').trim(),
        active: true,
        slug: pageData.slug || '',
        metadata_uri: pageData.metadata_uri || pageData.metadata?.uri || ''
      };

      try {
        // Properly escape the data
        const jsonString = JSON.stringify(safePageData)
          .replace(/'/g, "\\'") // Escape single quotes
          .replace(/"/g, '\\"'); // Escape double quotes
        saveBtn.dataset.page = jsonString;
      } catch (error) {
        console.error('Failed to save data:', error);
      }
    }


    // Update title section
    const h3 = card.querySelector('.page-title h3');
    if (h3) h3.textContent = pageData.title || `Page #${pageData.id}`;

    // Update description
    const description = card.querySelector('.dashboard-page-description');
    if (description) description.textContent = pageData.description || 'No description available';

    // Update status badge in the correct location
    const statusBadge = card.querySelector('.status-badge');
    if (statusBadge) {
      statusBadge.className = `status-badge ${pageData.active ? 'active' : 'inactive'}`;
      statusBadge.textContent = pageData.active ? 'Active' : 'Inactive';
    }

    // Update settings panel inputs
    const titleInput = card.querySelector('.page-title-input');
    if (titleInput) {
      titleInput.value = pageData.title;
    }

    const descriptionInput = card.querySelector('.page-description-input');
    if (descriptionInput) {
      descriptionInput.value = pageData.description || '';
    }

    // Update character counters
    const titleCounter = card.querySelector(`#edit-title-counter-${pageData.id}`);
    if (titleCounter) {
      titleCounter.textContent = (pageData.title || '').length;
    }

    const descriptionCounter = card.querySelector(`#edit-description-counter-${pageData.id}`);
    if (descriptionCounter) {
      descriptionCounter.textContent = (pageData.description || '').length;
    }

    // Update festive toggle if it exists
    const festiveToggle = card.querySelector(`#festive-${pageData.id}`);
    if (festiveToggle && pageData.metadata?.attributes) {
      const isFestive = pageData.metadata.attributes.find(
        attr => attr.trait_type === "Festive Mode"
      )?.value === "On";
      festiveToggle.checked = isFestive;
    }



    // Ensure settings panel is hidden
    const settingsPanel = card.querySelector('.settings-panel');
    if (settingsPanel) {
      settingsPanel.classList.add('none');
    }

    // Make sure all classes are preserved
    card.className = 'page-card';
    const pageHeader = card.querySelector('.page-header');
    if (pageHeader) {
      pageHeader.className = 'page-header';
    }
    const pageTitle = card.querySelector('.page-title');
    if (pageTitle) {
      pageTitle.className = 'page-title';
    }
    const pageActions = card.querySelector('.page-actions');
    if (pageActions) {
      pageActions.className = 'page-actions';
    }
  }

  resetFormToOriginal(card) {
    const panel = card.querySelector('.settings-panel');
    const originalData = JSON.parse(panel.querySelector('.save-btn').dataset.page || '{}');

    const titleInput = panel.querySelector('input[type="text"]');
    const descriptionInput = panel.querySelector('textarea');
    const activeToggle = panel.querySelector('input[type="checkbox"]');

    if (titleInput) titleInput.value = originalData.title || '';
    if (descriptionInput) descriptionInput.value = originalData.description || '';
    if (activeToggle) activeToggle.checked = originalData.active || false;
  }

  initializeCancelButtons() {
    document.querySelectorAll('.cancel-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        // Modal close handlers

        const modal = document.getElementById('create-page-modal');
        const form = document.getElementById('create-page-form');
        if (modal) {
          modal.style.display = 'none';
          if (form) {
            form.reset();
            // Reset the counter displays
            document.getElementById('title-counter').textContent = '0';
            document.getElementById('description-counter').textContent = '0';
          }
        }


        if (this.currentEffect) {
          document.body.removeChild(this.currentEffect.canvas);
          this.currentEffect = null;
        }
        const panel = e.target.closest('.settings-panel');
        if (panel) {
          panel.classList.add('none');
          this.resetFormToOriginal(panel.closest('.page-card'));
        }
      });
    });
  }

  setupGlobalErrorHandler() {
    window.addEventListener('unhandledrejection', event => {
      this.handleError('An unexpected error occurred', event.reason);
    });
  }

  handleError(message, error) {
    console.error(message, error);

    const errorElement = document.createElement('div');
    errorElement.className = 'error-toast';
    errorElement.textContent = `${message}: ${error.message || 'Unknown error'}`;

    document.body.appendChild(errorElement);
    setTimeout(() => errorElement.remove(), 5000);
  }

  getEmptyState() {
    return `
      <div class="empty-state">
        <p>No pages found. Create your first page!</p>
        <button class="create-page-btn">Create Page</button>
      </div>
    `;
  }

  getErrorState(stxAddress) {
    return `
      <div class="error-state">
        <p>Error loading your pages. Please try again.</p>
        <button onclick="window.router.loadPages('${this.escapeHtml(stxAddress)}')" class="retry-btn">
          Retry
        </button>
      </div>
    `;
  }

  escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  initializeMusicPlayer() {
    console.log('Router: Starting music player initialization with auth:', this.auth);

    if (!window.musicPlayer) {
      window.musicPlayer = { ...musicPlayer };
      window.musicPlayer.auth = this.auth;  // Set auth on window.musicPlayer

      if (!window.musicPlayer.isInitialized) {
        window.musicPlayer.init();
      }
    }

    // Ensure auth is set even if musicPlayer already exists
    window.musicPlayer.auth = this.auth;
  }


  async handleRoute() {
    if (this.isHandlingRoute) {
      console.log('Already handling route, skipping');
      return;
    }

    this.isHandlingRoute = true;

    const isSignedIn = this.auth.userSession.isUserSignedIn();

    if (!isSignedIn) {
      console.log('No wallet detected');
    }

    if (!this.mainContent) {
      console.error('Main content element not initialized!');
      this.isHandlingRoute = false; // Make sure to reset the flag here
      return;
    }

    try {
      const parsedUrl = this.parseUrl();
      this._lastParsedUrl = parsedUrl;
      console.log('Starting route handling with:', parsedUrl);

      // Check stored auth state first - make sure this is up to date
      if (this.auth) {
        const authStateUpdated = this.auth.checkStoredAuthState();
        console.log('Auth state check result:', authStateUpdated);
        console.log('Auth state stx address:', this.auth.stxAddress);
      }

      // Dashboard check with enhanced auth verification
      if (parsedUrl.stxAddress) {
        // Get the current auth status - force a fresh check
        const currentAddress = this.auth?.getCurrentAddress()?.toLowerCase();
        const parsedAddress = parsedUrl.stxAddress?.toLowerCase();
        const isSignedIn = this.auth?.isSignedIn();

        console.log('Dashboard auth check:', {
          currentAddress,
          parsedAddress,
          isSignedIn,
          hasStoredAuth: Boolean(localStorage.getItem('authAddress')),
          userSessionSignedIn: this.auth?.userSession.isUserSignedIn(),
          hasPageTitle: Boolean(parsedUrl.hasPageTitle),
          pageTitle: parsedUrl.pageTitle
        });

        // IMPORTANT: If there's a page title in the URL, we should use the "page" route
        // rather than showing the claim page
        if (parsedUrl.hasPageTitle && parsedUrl.pageTitle) {
          console.log('URL has a page title, allowing route matching to proceed');
          // Don't return here - let it fall through to route matching
        }
        // Otherwise, handle subdomain-only URLs based on authentication
        else {
          // Check if addresses match and user is viewing their own address
          if (currentAddress === parsedAddress) {
            // IMPORTANT FIX: Check the auth state more thoroughly
            const userSessionSignedIn = this.auth?.userSession.isUserSignedIn();
            const hasAuthInStorage = localStorage.getItem('isAuthenticated') === 'true';

            // If ANY auth indicator is positive, treat as signed in
            if ((isSignedIn || userSessionSignedIn || hasAuthInStorage)) {
              console.log('User authenticated, rendering dashboard');
              await this.renderAdminDashboard(parsedUrl.stxAddress);
              return;
            }
          }
          // This is an important case - user is authenticated but viewing someone else's address
          else if (isSignedIn && currentAddress !== parsedAddress) {
            console.log('Authenticated user viewing other address, rendering claim page');
            await this.renderClaimPage(parsedUrl.stxAddress);
            return;
          }
          // Non-authenticated user viewing a subdomain without a page title
          else if (!isSignedIn) {
            console.log('Non-authenticated user viewing a subdomain without page title, rendering claim page');
            await this.renderClaimPage(parsedUrl.stxAddress);
            return;
          }
        }
      }

      // Route matching with detailed logging
      console.log('Checking routes for:', parsedUrl);
      const matchingRoute = Object.entries(this.routeHandlers)
        .find(([name, handler]) => {
          console.log(`Checking route '${name}'...`);
          if (!handler || typeof handler.match !== 'function') {
            console.error(`Invalid handler for route '${name}'`);
            return false;
          }
          const matches = handler.match(parsedUrl);
          console.log(`Route '${name}' match result:`, matches);
          return Boolean(matches);
        });

      if (matchingRoute) {
        console.log('Rendering route:', matchingRoute[0]);
      await matchingRoute[1].render(parsedUrl.stxAddress, parsedUrl.pageTitle, this);
        return;
      }

      console.log('No matching route found for:', parsedUrl);
    } catch (error) {
      console.error('Error handling route:', error);
    } finally {
      this.isHandlingRoute = false;
    }
  }

  async checkPageExists(stxAddress) {
    try {
      // Implement check against your smart contract
      // Example using your gated smart contract:
      const contractCall = await this.makeContractCall('get-page-by-id', [stxAddress]);
      return contractCall && contractCall.success;
    } catch (error) {
      console.error('Error checking page existence:', error);
      return false;
    }
  }

  // Add this method to your Router class or update if it exists
async checkExistingSession() {
    try {
      if (!this.auth) {
        console.error('Auth service not initialized');
        return false;
      }

      // Check if user is signed in
      const isSignedIn = this.auth.isSignedIn();
      const userSessionSignedIn = this.auth.userSession.isUserSignedIn();
      const hasAuthInStorage = localStorage.getItem('isAuthenticated') === 'true';

      console.log('Session check:', { isSignedIn, userSessionSignedIn, hasAuthInStorage });

      // If any auth indicator is positive, user is signed in
      if (isSignedIn || userSessionSignedIn || hasAuthInStorage) {
        // Get current user address
        const userAddress = this.auth.getCurrentAddress();

        if (userAddress) {
          this.currentStxAddress = userAddress;
          window.stxAddress = userAddress;

          // Check if this is a BNS route - if so, don't redirect
          const currentHash = window.location.hash;
          if (currentHash && currentHash.includes('.btc')) {
            console.log('🔗 BNS route detected, staying on main domain');
            return true; // User is authenticated, but don't redirect for BNS routes
          }

          // Check if we're already on the correct subdomain
          const currentHostname = window.location.hostname;
          const userSubdomain = userAddress.toLowerCase();

          // If not on user's subdomain, redirect (but only for non-BNS routes)
          if (!currentHostname.startsWith(userSubdomain)) {
            console.log('User authenticated but on wrong subdomain, redirecting');
            this.auth.redirectToUserSubdomain();
            return true;
          }

          console.log('User authenticated and on correct subdomain');
          return true;
        }
      }

      console.log('User not authenticated');
      return false;
    } catch (error) {
      console.error('Error checking session:', error);
      return false;
    }
  }

  parseUrl() {
    const host = window.location.hostname;
    const hash = window.location.hash.slice(1) || '/';
    const pathname = window.location.pathname;
    const storedAddress = this.auth?.currentAddress || localStorage.getItem('authAddress');

    console.log('Auth state debug1:', this.auth.currentAddress)
    console.log('Auth state debug2:', {
      isSignedIn: this.auth?.userSession.isUserSignedIn(),
      localStorageAuth: localStorage.getItem('isAuthenticated'),
      localStorageAddr: localStorage.getItem('authAddress')
    });

    console.log('Parsing URL:', {
      host,
      hash,
      pathname,
      storedAddress,
      fullUrl: window.location.href
    });

    // Handle auth redirect first
    if (pathname === '/auth') {
      if (this.auth?.userSession.isSignInPending()) {
        this.auth.handlePendingSignIn();
      }
      window.location.href = '/';
      return { stxAddress: null, pageTitle: null };
    }

    // Improve page title parsing
    const hasPageTitle = hash.startsWith('/');
    const rawPageTitle = hasPageTitle ? hash.slice(1) : hash;
    const pageTitle = rawPageTitle ? decodeURIComponent(rawPageTitle) : null;

    let pathAlbum = null;
    const pathSegs = pathname.split('/').filter(Boolean);
    const reservedPath = new Set(['api', 'auth']);
    if (
      pathSegs.length === 2 &&
      !reservedPath.has(pathSegs[0].toLowerCase()) &&
      /^[a-z0-9-]+$/i.test(pathSegs[0]) &&
      /^[a-z0-9-]+$/i.test(pathSegs[1])
    ) {
      pathAlbum = {
        creator: pathSegs[0].toLowerCase(),
        slug: pathSegs[1].toLowerCase()
      };
    }

    let stxAddress;
    if (pathAlbum) {
      stxAddress = null;
    } else {
      const stxAddressMatch = host.match(/^([a-zA-Z0-9]+)\.(localhost|gated\.so)$/);
      stxAddress = stxAddressMatch ? stxAddressMatch[1] : storedAddress;
    }

    const parsed = {
      stxAddress,
      pageTitle,
      hasPageTitle,
      authAddress: storedAddress,
      isProduction: host.includes('gated.so'),
      pathAlbum
    };
    console.log('Parsed URL result:', parsed);  // Add this debug log
    const isSubdomain = host.match(/^([a-zA-Z0-9]+)\.(localhost|gated\.so)$/);

    // // If we have an authenticated address but aren't on a subdomain, redirect
    // if (storedAddress && !isSubdomain && storedAddress !== "null") {
    //   const isLocalhost = host.includes('localhost');
    //   const baseHost = isLocalhost ? 'localhost:3000' : 'gated.so';
    //   const protocol = isLocalhost ? 'http://' : 'https://';
    //   const newUrl = `${protocol}${storedAddress}.${baseHost}${pathname}${hash ? '#' + hash : ''}`;

    //   console.log(`Redirecting to subdomain: ${newUrl}`);
    //   window.location.href = newUrl;


    return parsed;
  }

  setCurrentStxAddress(address) {
    this.currentStxAddress = address;
    if (this.mainContent) {
      this.handleRoute();
    }
  }

  navigate(path, stxAddress = null) {
    const baseUrl = stxAddress
      ? `${window.location.protocol}//${stxAddress}.${window.location.host}`
      : window.location.origin;

    const newUrl = `${baseUrl}${path}`;
    window.history.pushState({}, '', newUrl);
    this.handleRoute();
  }

  navigateToAdmin(currentAddress) {
    console.log('Navigating to admin with:', {
      currentAddress,
      isSignedIn: this.auth.isSignedIn(),
      authState: this.auth,
      currentLocation: window.location.href
    });

    if (!currentAddress) {
      console.error('No current address available for navigation');
      return;
    }

    // Get the base domain depending on environment
    const baseUrl = window.location.hostname.includes('localhost')
      ? 'localhost:3000'
      : 'gated.so';

    // Construct the dashboard URL
    const dashboardUrl = `${window.location.protocol}//${currentAddress}.${baseUrl}`;

    console.log('Constructed dashboard URL:', dashboardUrl);

    // Before navigation, verify auth state
    if (!this.auth.isSignedIn()) {
      console.warn('User not signed in before navigation');
      return;
    }

    // Navigate to dashboard
    window.location.href = dashboardUrl;
  }

  getPageUrl(stxAddress, pageTitle) {
    const domain = window.location.hostname.includes('gated.so') ? 'gated.so' : 'localhost';
    return `${window.location.protocol}//${stxAddress}.${domain}/#/${pageTitle}`;
  }

  // You might also want to update the getDashboardUrl method to match:
  getDashboardUrl(stxAddress) {
    if (!stxAddress) {
      const userData = this.auth.userSession.loadUserData();
      if (!userData || !userData.profile?.stxAddress) {
        throw new Error("No user data found. Did the user sign in?");
      }
      stxAddress = userData.profile.stxAddress;
    }

    const isTestnet = window.location.hostname.includes('localhost') || window.location.hostname.includes('testnet');
    const domain = isTestnet ? 'localhost:3000' : 'gated.so';

    console.log('Dashboard URL generation:', {
      stxAddress,
      isTestnet,
      domain
    });

    return `${window.location.protocol}//${stxAddress.toLowerCase()}.${domain}`;
  }
  

  renderHomePage() {

    if (this.auth?.isSignedIn() && this.auth.getCurrentAddress()) {
      console.log('User is signed in, redirecting from home to dashboard');
      const stxAddress = this.auth.getCurrentAddress();
      this.renderAdminDashboard(stxAddress);
      return;
    }

    console.log('Starting renderHomePage');
    console.log('Auth object:', this.auth);


    const isSignedIn = this.auth.isSignedIn();
    const currentAddress = this.auth.getCurrentAddress();



    this.mainContent.innerHTML = `
    <div class="home-page">
        <img src=${gatedLogo} alt="Gated Logo" class="logo" style="width:400px;padding:40px;cursor:auto;"/>
        ${isSignedIn ? `
            <div id="wallet-container">
                <div class="dropdown">
                    <div class="button-group">
                        <button 
                            id="dashboard-nav-btn"
                            class="dashboard-btn"
                        >
                            Go to Dashboard
                        </button>
                        <button 
                            id="wallet-dropdown-btn" 
                            class="dropdown-toggle-btn"
                            aria-label="Toggle menu"
                        >
                            <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </button>
                    </div>
                    <div id="wallet-dropdown-content" class="dropdown-content">
                        <a id="disconnect-wallet-btn" class="dropdown-item">Disconnect</a>
                    </div>
                </div>
            </div>
        ` : `
            <button id="connectWallet-button" class="connect-btn">
                Connect Wallet
            </button>
        `}
    </div>
`;

    // Add event listeners after rendering HTML
    if (isSignedIn) {
      // Dashboard navigation
      const dashboardBtn = document.getElementById('dashboard-nav-btn');
      if (dashboardBtn) {
        dashboardBtn.addEventListener('click', () => {
          this.navigateToAdmin(currentAddress);
        });
      }

      // Setup wallet dropdown
      this.setupWalletDropdown();


      // Disconnect button
      const disconnectBtn = document.getElementById('disconnect-wallet-btn');
      if (disconnectBtn) {
        disconnectBtn.addEventListener('click', () => {
          window.disconnectWallet();
        });
      }
    } else {
      // Connect button
      const connectButton = document.getElementById('connectWallet-button');
      if (connectButton) {
        connectButton.addEventListener('click', () => {
          window.connectWallet();
        });
      }
    }
  }
  async loadPages(stxAddress) {
    const pagesList = document.getElementById('pages-list');

    // Replace loading text with skeleton loader
    pagesList.innerHTML = this.getSkeletonLoader();

    try {
      const { pages } = await this.fetchNFTPages();
      console.log('Raw pages from blockchain:', pages);

      if (!pages?.length) {
        pagesList.innerHTML = this.getEmptyState();
        return;
      }

      // Filter pages to ensure ownership
      const userOwnedPages = pages.filter(page =>
        page.owner?.toLowerCase() === stxAddress.toLowerCase()
      );
      console.log(`Pages owned by ${stxAddress}:`, userOwnedPages);

      if (!userOwnedPages.length) {
        console.warn(`No pages owned by ${stxAddress}`);
        pagesList.innerHTML = this.getEmptyState();
        return;
      }

      // Process pages with strict contract type handling
      const processedPages = userOwnedPages.map(page => {
        const pageContractType = page.contractType;
        if (!pageContractType) {
          console.error('Page missing contract type:', page);
          throw new Error(`Page ${page.id} is missing contract type`);
        }

        return {
          ...page,
          contractType: pageContractType // Use only the contract field
        };
      });

      console.log('Processed pages:', processedPages.map(p => ({
        id: p.id,
        contractType: p.contractType,
        title: p.title
      })));

      pagesList.innerHTML = `
          <div class="dashboard-view">
              ${processedPages.map(page => this.renderPageCard(page)).join('')}
          </div>
          <div class="page-edit-panel none"></div>
      `;

      this.initializePageHandlers();

      // Initialize counters for each page
      processedPages.forEach(page => {
        this.initializeCharCounters(page);
      });

    } catch (error) {
      console.error('Error loading pages:', error);
      pagesList.innerHTML = this.getErrorState(stxAddress);
    }
  }

  // Add this new method to generate the skeleton loader
  getSkeletonLoader() {
    // Create 3 skeleton cards (adjust number as needed)
    return `
    <div class="dashboard-view skeleton-container">
      ${Array(3).fill().map(() => `
        <div class="page-card skeleton">
          <div class="skeleton-header">
            <div class="skeleton-title"></div>
            <div class="skeleton-badge"></div>
          </div>
          <div class="skeleton-content">
            <div class="skeleton-line"></div>
            <div class="skeleton-line"></div>
            <div class="skeleton-line short"></div>
          </div>
          <div class="skeleton-footer">
            <div class="skeleton-button"></div>
            <div class="skeleton-button"></div>
          </div>
        </div>
      `).join('')}
    </div>
  `;
  }


  renderPageCard(page) {
    const userSession = new UserSession();
    const userData = userSession.loadUserData();
    const senderAddress = userData.profile.stxAddress.mainnet;

    // Debug logging
    console.log('========= renderPageCard called =========');
    console.log('Raw page data:', page);

    // Add extensive validation and logging
    if (!page) {
      console.error('Page object is null or undefined');
      return '';
    }

    if (!page.contractType) {
      console.warn('Page has no contract type:', page);
    }

    console.log('Rendering page:', {
      contractType: page.contractType,
      id: page.id,
      title: page.title || '',
      description: page.description || '',
      active: !!page.active,
      metadata: page.metadata || { attributes: [] }
    });

    const MAX_TITLE_LENGTH = 64;
    const MAX_DESCRIPTION_LENGTH = 256;

    console.log('Metadata before processing:', page.metadata);

    // Ensure metadata structure exists
    if (!page.metadata) {
      console.log('No metadata found, initializing empty structure');
      page.metadata = { attributes: [] };
    }
    if (!page.metadata.attributes) {
      console.log('No attributes found, initializing empty array');
      page.metadata.attributes = [];
    }

    console.log('Current attributes:', page.metadata.attributes);

    // When creating safePageData, ensure we're properly copying metadata
    const safePageData = {
      id: page.id,
      title: page.title || '',
      description: page.description || '',
      active: !!page.active,
      contractType: page.contractType,
      metadata: {
        ...page.metadata,
        attributes: [...(page.metadata.attributes || [])]
      }
    };

    console.log('Safe page data:', safePageData);

    return `
    <div id="page-${page.id}" class="page-card" data-contract-type="${page.contractType}">
      <div class="page-header">
        <div class="page-title">
          <h3>${page.title || `Page #${page.id}`}</h3>
          <div class="status-badge ${page.active ? 'active' : 'inactive'}">
            ${page.active ? 'Active' : 'Inactive'}
          </div>
        </div>
        <div class="page-actions">
<a href="#/${this.sanitizeUrl(page.title)}" class="view-btn">View & Edit Page</a>

        </div>
      </div>
      
      <div class="settings-panel none">
        <div class="settings-section">
          <h4>Page Settings</h4>
          <div class="settings-group">
            <label>Title</label>
            <input type="text"
             class="page-title-input"
             value="${page.title}"
             maxlength="${MAX_TITLE_LENGTH}" />
            <div class="char-count-title">
             <span id="edit-title-counter-${page.id}">0</span>/${MAX_TITLE_LENGTH}
           </div>
          </div>
          <div class="settings-group">
            <label>Description</label>
             <textarea
             class="page-description-input"
             rows="3"
             maxlength="${MAX_DESCRIPTION_LENGTH}">${page.description || ''}</textarea>
              <div class="char-count-title">
              <span id="edit-description-counter-${page.id}">0</span>/${MAX_DESCRIPTION_LENGTH}
              </div>
          </div>
        </div>
        
        <div class="settings-footer">
      <button
  class="delete-btn"
  data-page='${JSON.stringify({
      id: page.id,
      title: page.title,
      description: page.description,
      stxAddress: senderAddress,
      contractType: page.contractType
    }).replace(/'/g, "&apos;")}'>
  Unpublish Page
</button>          
      <div class="action-buttons">
            <button class="btn btn-secondary cancel-btn">Cancel</button>
              <button
              class="save-btn"
data-page='${JSON.stringify(safePageData).replace(/'/g, "&apos;")}'
              data-contract-type="${page.contractType}" 
              >
              Next
          </button>            
          </div>
        </div>
      </div>
    </div>
  `;
  }

  async attachFestiveListeners() {
    const toggles = document.querySelectorAll('.festive-toggle');

    toggles.forEach(toggle => {
      console.log('Attaching listener to toggle:', toggle.id);
      // Get initial state from page data
      const pageCard = toggle.closest('.page-card');
      const saveBtn = pageCard.querySelector('.save-btn');
      const pageData = JSON.parse(saveBtn.dataset.page);

      // Check both festive mode and NFT from metadata
      const festiveMode = pageData?.metadata?.attributes?.find(
        attr => attr.trait_type === "Festive Mode" && attr.value === "On"
      );
      const currentFestiveNFT = pageData?.metadata?.attributes?.find(
        attr => attr.trait_type === "Festive NFT"
      )?.value;

      let tokenId = null;

      if (currentFestiveNFT) {
        const [contractAddress, assetName] = currentFestiveNFT.split('::');
        tokenId = assetName; // Extract the token ID from the currentFestiveNFT
      }

      console.log('Initial state:', { festiveMode, currentFestiveNFT, tokenId });


      if (festiveMode && currentFestiveNFT) {

        const nftValue = typeof currentFestiveNFT === 'string' ?
          currentFestiveNFT :
          currentFestiveNFT.value;


        // Initialize fall effect for current NFT
        const contractAddress = nftValue.split('::')[0];
        const imageUrl = `https://assets.hiro.so/api/mainnet/token-metadata-api/${contractAddress}/1.png`;

        // Populate other NFTs immediately
        const dropdownContainer = pageCard.querySelector('.nft-dropdown-container');
        if (dropdownContainer) {
          this.populateNFTOptions(dropdownContainer, nftValue);
        }
      }

      // If festive mode is on, set the toggle and create dropdown
      if (festiveMode) {
        console.log('Setting up initial festive state');
        toggle.checked = true;

        // Create and populate dropdown immediately
        let dropdownContainer = pageCard.querySelector('.nft-dropdown-container');
        if (!dropdownContainer) {
          dropdownContainer = document.createElement('div');
          dropdownContainer.className = 'nft-dropdown-container';
          dropdownContainer.style.marginTop = '10px';

          // Add to DOM
          const settingsGroup = toggle.closest('.settings-group');
          if (settingsGroup) {
            settingsGroup.appendChild(dropdownContainer);
          }

          // Trigger the change event which will populate the dropdown
          const event = new Event('change');
          toggle.dispatchEvent(event);
        }
      }

      toggle.addEventListener('change', async (e) => {
        const isChecked = e.target.checked;

        // Log the full page data to see what we're working with
        console.log('Page data:', pageData);

        // First, get the current festive NFT from attributes
        const currentFestiveNFT = pageData?.metadata?.attributes?.find(
          attr => attr.trait_type === "Festive NFT"
        )?.value;

        console.log('Current Festive NFT from attributes:', currentFestiveNFT);

        let dropdownContainer = pageCard.querySelector('.nft-dropdown-container');

        if (isChecked) {
          console.log("ischecked", isChecked)

          if (!dropdownContainer) {
            console.log('Creating new dropdown container');
            dropdownContainer = document.createElement('div');
            dropdownContainer.className = 'nft-dropdown-container';
            dropdownContainer.style.marginTop = '10px';


            dropdownContainer.innerHTML = `
                <select class="nft-select">
                  <option value="">Loading NFTs...</option>
                </select>
      `;
            // Insert the dropdown
            const settingsGroup = e.target.closest('.settings-group');
            if (settingsGroup) {
              settingsGroup.appendChild(dropdownContainer);
            }
          } else {
            // If container exists, just show it
            dropdownContainer.style.display = 'block';
          }

          try {
            // Fetch NFTs
            const userSession = new UserSession();
            const userData = userSession.loadUserData();
            const userAddress = userData.profile.stxAddress.mainnet;

            const nftData = await this.fetchNFTs(userAddress);
            console.log('Fetched NFT data:', nftData);

            const select = dropdownContainer.querySelector('.nft-select');
            select.innerHTML = '<option value="">Select an NFT</option>';

            if (nftData && nftData.results) {
              let foundCurrentNFT = false;

              console.log('Processing NFTs with currentFestiveNFT:', currentFestiveNFT);

              // Process all NFTs except the currently selected one
              for (const nft of nftData.results) {

                const [contractAddress, assetName] = nft.asset_identifier.split('::');
                const tokenId = nft.value.repr.replace('u', '');
                const nftIdentifier = nft.asset_identifier; // Full identifier
                const NFTimageUrl = `https://assets.hiro.so/api/mainnet/token-metadata-api/${contractAddress}/${tokenId}.png`;

                console.log('Processing NFT:', {
                  identifier: nftIdentifier,
                  currentFestiveNFT,
                  tokenId,
                  isMatch: nftIdentifier === currentFestiveNFT
                });

                const option = document.createElement('option');
                option.value = nft.asset_identifier;
                option.id = tokenId,
                  option.textContent = `${assetName} #${tokenId}`; // Name followed by ID
                option.dataset.NFTimageUrl = NFTimageUrl;

                select.appendChild(option);
              }
              console.log('Found current NFT in options:', foundCurrentNFT);

              // Add change listener to show preview
              select.addEventListener('change', (e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const NFTimageUrl = selectedOption.dataset.NFTimageUrl;
                const selectedName = selectedOption.textContent.split(' (ID: ')[0]; // Extract name
                const selectedId = selectedOption.id;

                console.log('Selected NFT Name:', selectedName);
                console.log('Selected NFT ID:', selectedId);
                // Update preview
                const previewDiv = dropdownContainer.querySelector('.nft-preview')
                  || document.createElement('div');
                previewDiv.className = 'nft-preview';
                previewDiv.style.marginTop = '10px';

                if (NFTimageUrl) {
                  previewDiv.innerHTML = `
                                        <img src="${NFTimageUrl}" 
                                            alt="NFT Preview" 
                                            style="max-width: 100px; height: auto; border-radius: 4px;">
                                    `;
                  if (!previewDiv.parentNode) {
                    dropdownContainer.appendChild(previewDiv);
                  }

                  // Update fall effect
                  if (this.currentEffect) {
                    document.body.removeChild(this.currentEffect.canvas);
                    this.currentEffect = null;
                  }
                  this.currentEffect = initNFTFallEffect(NFTimageUrl);
                }

                // Update page data
                try {
                  const pageData = JSON.parse(saveBtn.dataset.page);

                  // Update attribute
                  const nftIndex = pageData.metadata.attributes.findIndex(
                    attr => attr.trait_type === "Festive NFT"
                  );
                  if (nftIndex >= 0) {
                    pageData.metadata.attributes[nftIndex].value = nftId;
                  } else {
                    pageData.metadata.attributes.push({
                      trait_type: "Festive NFT",
                      value: nftId
                    });
                  }

                  // Update properties structure
                  if (!pageData.metadata.properties) pageData.metadata.properties = {};
                  if (!pageData.metadata.properties.meta) pageData.metadata.properties.meta = {};
                  if (!pageData.metadata.properties.meta.content) pageData.metadata.properties.meta.content = {};

                  pageData.metadata.properties.meta.content.festive = {
                    enabled: true,
                    nft: {
                      identifier: nftIdentifier,
                      name: selectedOption.textContent,
                      imageUrl: NFTimageUrl
                    }
                  };

                  saveBtn.dataset.page = JSON.stringify(pageData);
                } catch (error) {
                  console.error('Error updating page data:', error);
                }
              });

              dropdownContainer.style.display = 'block';

            }
          } catch (error) {
            console.error('Error loading NFTs:', error);
            const select = dropdownContainer.querySelector('.nft-select');
            if (select) select.innerHTML = '<option value="">Error loading NFTs</option>';
          }
        } else {
          if (dropdownContainer) {
            console.log('hiding dropdown container');
            dropdownContainer.style.display = 'none';
          }

          // Remove the effect when festive mode is turned off
          if (this.currentEffect) {
            document.body.removeChild(this.currentEffect.canvas);
            this.currentEffect = null;
          }
        }
      });
    });
  }

  updateNFTPreview(container, imageUrl) {
    const previewDiv = container.querySelector('.nft-preview')
      || document.createElement('div');
    previewDiv.className = 'nft-preview';
    previewDiv.style.marginTop = '10px';
    previewDiv.innerHTML = `
    <img src="${imageUrl}" 
      alt="NFT Preview" 
      style="max-width: 100px; height: auto; border-radius: 4px;">
  `;
    if (!previewDiv.parentNode) {
      container.appendChild(previewDiv);
    }
  }

  async fetchNFTs(walletAddress) {
    const url = `/api/proxy/stacks?principal=${walletAddress}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching NFT data:', error);
    }
  }

  initializeCharCounters(page) {
    const titleInput = document.querySelector(`#page-${page.id} .page-title-input`);
    const descInput = document.querySelector(`#page-${page.id} .page-description-input`);
    const titleCounter = document.querySelector(`#edit-title-counter-${page.id}`);
    const descCounter = document.querySelector(`#edit-description-counter-${page.id}`);

    if (titleInput) {
      titleCounter.textContent = titleInput.value.length;
      titleInput.addEventListener('input', () => {
        titleCounter.textContent = titleInput.value.length;
      });
    }

    if (descInput) {
      descCounter.textContent = descInput.value.length;
      descInput.addEventListener('input', () => {
        descCounter.textContent = descInput.value.length;
      });
    }
  }

  async togglePageStatus(id, currentStatus) {
    const button = event.currentTarget;
    button.disabled = true;

    try {
      await this.updatePage({
        id,
        active: currentStatus,
        // Add other required fields here
      });
    } catch (error) {
      console.error('Toggle failed:', error);
      // Reset button state
      button.textContent = currentStatus ? 'Unpublish' : 'Publish';
      button.classList.toggle('active', currentStatus);
    } finally {
      button.disabled = false;
    }
  }

  async fetchNFTPages(stxAddress = null, forceRefresh = false) {
    try {
      // 1. Return early if already loaded and not forcing refresh
      if (!forceRefresh && this.pages && this.pages.length > 0) {
        console.log('Pages already loaded, skipping fetch');
        return { pages: this.pages, nfts: [] };
      }

      // 2. Get user address
      let userAddressMainnet;
      if (stxAddress) {
        userAddressMainnet = stxAddress;
      } else {
        const userData = this.auth.userSession.loadUserData();
        userAddressMainnet = userData.profile.stxAddress.mainnet;
      }

      console.log('Fetching NFTs for mainnet address:', userAddressMainnet);

      // 3. Load cached pages if no in-memory cache yet
      if (!this.cachedPages) {
        this.cachedPages = [];
        try {
          const cachedData = localStorage.getItem(`nft_pages_${userAddressMainnet}`);
          if (cachedData) {
            const parsed = JSON.parse(cachedData);
            if (Array.isArray(parsed) && parsed.length > 0) {
              this.cachedPages = parsed;
              console.log(`Loaded ${parsed.length} pages from localStorage`);

              // If not forcing refresh, use cache immediately
              if (!forceRefresh) {
                this.pages = this.cachedPages;
                return { pages: this.pages, nfts: [] };
              }
            }
          }
        } catch (cacheError) {
          console.warn('Error loading from cache:', cacheError);
        }
      }

      // 4. Fetch NFTs from the network
      const nftHoldingsUrl = `https://api.hiro.so/extended/v1/tokens/nft/holdings?principal=${userAddressMainnet}&limit=50`;

      const holdingsResponse = await this.fetchWithRetry(nftHoldingsUrl);
      if (!holdingsResponse) throw new Error('Failed to fetch NFT holdings');

      const holdingsData = await holdingsResponse.json();
      if (!holdingsData.results?.length) {
        console.warn('No NFTs found for address');
        return { pages: [], nfts: [] };
      }

      const sortedNFTs = holdingsData.results.sort((a, b) => b.block_height - a.block_height);
      console.log(`Found ${sortedNFTs.length} NFTs total`);

      // 5. Filter for only gated-page NFTs
      const gatedPageNFTs = sortedNFTs.filter(nft => {
        const [contractPart, assetName] = nft.asset_identifier.split('::');
        return contractPart === 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5.gated-pages' &&
          assetName === 'gated-page';
      });

      console.log(`Found ${gatedPageNFTs.length} gated-page NFTs to process`);

      // 6. Process each NFT to create page objects
      const processedContent = [];

      for (const nft of gatedPageNFTs) {
        try {
          // Extract token ID
          const tokenId = parseInt(nft.value.repr.replace('u', ''), 10);
          console.log(`Processing NFT with token ID: ${tokenId}`);

          // Fetch page data from contract
          const pageDataOptions = {
            contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
            contractName: 'gated-pages',
            functionName: 'get-page-by-id',
            functionArgs: [uintCV(tokenId)],
            network: STACKS_MAINNET,
            senderAddress: userAddressMainnet
          };

          const pageDataResult = await fetchCallReadOnlyFunction(pageDataOptions);

          if (!pageDataResult || !pageDataResult.value) {
            console.warn(`No page data found for token ${tokenId}`);
            continue;
          }

          // Extract page data
          const pageData = cvToJSON(pageDataResult);
          console.log(`Raw page data for token ${tokenId}:`, pageData);

          // Handle deeply nested Clarity tuple structure
          // The structure looks like: 
          // {type: "optional...", value: {type: "tuple...", value: {active: {type: 'bool', value: true}, ...}}}

          // Start with the outer object
          let tupleData = null;

          // First level unwrap - get the optional tuple's value
          if (pageData.value && typeof pageData.value === 'object') {
            // Second level unwrap - get the tuple's value
            if (pageData.value.value && typeof pageData.value.value === 'object') {
              tupleData = pageData.value.value;
              console.log(`Unwrapped deeply nested tuple for token ${tokenId}`, tupleData);
            } else {
              tupleData = pageData.value;
              console.log(`Unwrapped first level for token ${tokenId}`, tupleData);
            }
          } else {
            tupleData = pageData;
          }

          // Now extract the actual values from the tuple fields
          // Each field has structure {type: 'type-info', value: actual-value}

          // Extract title - should be in tupleData.title.value
          const title = tupleData.title?.value || null;

          // Extract description - should be in tupleData.description.value
          const description = tupleData.description?.value || null;

          // Extract metadata URI - should be in tupleData['metadata-uri']?.value
          const metadataUri = tupleData['metadata-uri']?.value || null;

          // Extract active status - should be in tupleData.active.value
          let active = false;
          if (tupleData.active?.value === true) {
            active = true;
          }

          // Extract owner - should be in tupleData.owner.value
          const owner = tupleData.owner?.value || userAddressMainnet;

          console.log(`Extracted values for token ${tokenId}:`, {
            title,
            description,
            metadataUri,
            active,
            owner,
            rawTupleData: tupleData
          });

          console.log(`Page ${tokenId} extracted data:`, {
            title,
            description,
            metadataUri,
            active,
            rawActive: tupleData // Log raw value for debugging
          });

          // Create initial page object
          const page = {
            type: 'page',
            id: tokenId,
            owner: owner,
            active: active,
            title: title || `Page ${tokenId}`,
            description: description || `Gated page #${tokenId}`,
            ipfsUri: metadataUri || '',
            assetIdentifier: nft.asset_identifier,
            tx_id: nft.tx_id,
            block_height: nft.block_height,
            contractType: 'gated-pages'
          };

          console.log(`Created page object for token ${tokenId}:`, page);

          // If we have a metadata URI, fetch additional data from IPFS
          if (metadataUri && metadataUri.startsWith('ipfs://')) {
            try {
              const ipfsUrl = metadataUri.replace('ipfs://', 'https://ipfs.io/ipfs/');
              console.log(`Fetching metadata from IPFS: ${ipfsUrl}`);

              const metadataResponse = await this.fetchWithRetry(ipfsUrl);
              if (metadataResponse && metadataResponse.ok) {
                const metadata = await metadataResponse.json();
                console.log(`Metadata from IPFS for token ${tokenId}:`, metadata);

                // Update page information with IPFS metadata
                if (metadata.name) {
                  page.title = metadata.name;
                  console.log(`Updated title from IPFS: "${page.title}"`);
                }

                if (metadata.description) {
                  page.description = metadata.description;
                  console.log(`Updated description from IPFS: "${page.description}"`);
                }

                // Store full metadata for future use
                page.metadata = metadata;
              }
            } catch (ipfsError) {
              console.warn(`Error fetching IPFS metadata for token ${tokenId}:`, ipfsError);
            }
          }

          // Add to processed content
          processedContent.push(page);
          console.log(`Successfully processed page: ${page.title} (ID: ${page.id})`);
        } catch (error) {
          console.error(`Error processing NFT ${nft.asset_identifier}:`, error);
        }
      }

      // 7. Sort by block height (newest first) and set as pages
      this.pages = processedContent.sort((a, b) => b.block_height - a.block_height);
      console.log(`Successfully processed ${this.pages.length} pages`);

      // 8. Save to localStorage
      if (this.pages.length > 0) {
        try {
          localStorage.setItem(`nft_pages_${userAddressMainnet}`, JSON.stringify(this.pages));
          console.log(`Cached ${this.pages.length} pages to localStorage`);
        } catch (cacheError) {
          console.warn('Error caching pages:', cacheError);
        }
      }

      return { pages: this.pages, nfts: [] };

    } catch (error) {
      console.error('Error in fetchNFTPages:', error);

      // 9. Fall back to cache or empty results on error
      if (this.pages && this.pages.length > 0) {
        console.log(`Returning ${this.pages.length} loaded pages despite error`);
        return { pages: this.pages, nfts: [] };
      }

      if (this.cachedPages && this.cachedPages.length > 0) {
        console.log(`Falling back to ${this.cachedPages.length} cached pages`);
        this.pages = this.cachedPages;
        return { pages: this.cachedPages, nfts: [] };
      }

      console.error('No pages available at all');
      return { pages: [], nfts: [] };
    }
  }

  async fetchWithRetry(url, options = {}, maxRetries = 10, initialDelay = 1000) {
    let lastError;
    let delay = initialDelay;

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        // Log retry attempts after the first try
        if (attempt > 0) {
          console.log(`Retry attempt ${attempt + 1}/${maxRetries} for: ${url}`);
        }

        const response = await fetch(url, options);

        // Check if the response is successful (status code 200-299)
        if (response.ok) {
          return response;
        }

        // If status is 429 (Too Many Requests), wait longer
        if (response.status === 429) {
          console.warn(`Rate limited (429) on attempt ${attempt + 1}, waiting longer...`);
          delay *= 2; // Exponential backoff
        }

        lastError = new Error(`HTTP error ${response.status}: ${response.statusText}`);
        console.warn(`Fetch failed with status ${response.status} on attempt ${attempt + 1}`);

      } catch (error) {
        console.warn(`Network error on attempt ${attempt + 1}:`, error.message);
        lastError = error;
      }

      // Wait before retrying, with exponential backoff
      await new Promise(resolve => setTimeout(resolve, delay));
      delay *= 1.5; // Increase delay for next retry
    }

    console.error(`All ${maxRetries} retry attempts failed for: ${url}`);
    throw lastError || new Error(`Failed to fetch after ${maxRetries} attempts`);
  }




  // Add these navigation methods
  viewNFTPage(contractAddress, tokenId) {
    // Implement view page navigation
    window.open(`/${contractAddress}/${tokenId}`, '_blank');
  }

  editNFTPage(contractAddress, tokenId) {
    // Implement edit page navigation
    window.location.href = `/edit/${contractAddress}/${tokenId}`;
  }


  renderClaimPage(stxAddress) {
    console.log('Starting renderClaimPage with address:', stxAddress);

    console.log('Auth object state:', {
      authObject: this.auth,
      userSession: this.auth.userSession,
      isSignedInMethod: this.auth.isSignedIn(),
      isUserSignedInSession: this.auth.userSession.isUserSignedIn()
    });



    // Add retry logic to check auth state
    const maxAttempts = 5;
    let attempts = 0;


    console.log(`Checking auth state, attempt ${attempts + 1} of ${maxAttempts}`);

    if (this.auth.userSession.isUserSignedIn()) {
      console.log('User is signed in, proceeding with render');

    };



    // Add delay to ensure auth state is ready
    setTimeout(async () => {
      // First check if session is still valid
      if (!this.auth.userSession.isUserSignedIn() && this.auth.isSignedIn()) {
        console.log('Session expired, triggering sign out');
        this.auth.handleSignOut();
        return;
      }

      let isSignedIn = false;

      if (stxAddress) {
        isSignedIn = true
        console.log("Signed in with address:", stxAddress)
      }
      const parsedUrl = this.parseUrl().stxAddress;
      if (parsedUrl) {
        console.log("Parsed URL:", parsedUrl)
      }

      // Normalize addresses to lowercase for comparison
      const normalizedPageAddress = parsedUrl?.toLowerCase();
      const normalizedCurrentAddress = stxAddress?.toLowerCase();
      const matchesPage = normalizedCurrentAddress === normalizedPageAddress;


      console.log('Claim page state:', {
        isSignedIn,
        stxAddress,
        normalizedCurrentAddress,
        normalizedPageAddress,
        matchesPage,
        network: window.location.hostname.includes('gated.so') ? 'mainnet' : 'testnet'
      });

      let contentToShow;

      if (!isSignedIn) {
        // Setup for unauthenticated users
        contentToShow = `
    <div class="wallet-connect-section">
      <p>To claim this page, connect your wallet:</p>
      <div class="action-buttons">
        <button id="connectWallet-button" class="primary-btn">
          Connect Wallet
        </button>
      </div>
    </div>
  `;
      } else if (matchesPage) {
        // User is signed in AND matches the page address
        console.log('User matches page, redirecting to dashboard');

        // Clear the current content to prevent flashing of claim page
        this.mainContent.innerHTML = `
    <div class="loading-container" style="display: flex; justify-content: center; align-items: center; height: 300px;">
      <div class="loading-message">
        <p>Redirecting to your dashboard...</p>
      </div>
    </div>
  `;
        console.log('Evaluating whether to redirect to dashboard...');

        const currentHostname = window.location.hostname;
        const expectedSubdomain = `${stxAddress.toLowerCase()}.gated.so`;
        const isLocalhost = currentHostname.includes('localhost');

        const isOnCorrectSubdomainRoot =
          (isLocalhost && window.location.pathname === '/') ||  // allow index on localhost
          (currentHostname === expectedSubdomain && (window.location.pathname === '/' || window.location.pathname === ''));
  
        if (matchesPage && isOnCorrectSubdomainRoot) {
          console.log('Already on correct subdomain, rendering dashboard here');
          this.renderHomePage(); // or whatever method builds the dashboard
          return;
          }
          

        // Return early to prevent further rendering
        return;

      } else {
        contentToShow = `
            <div class="error-message">
                <p>❌ Your wallet is connected to a different address:</p>
                <p class="suggestion">
                    Perhaps you were looking for
                    <a href="https://${currentAddress.toLowerCase()}.gated.so">
                        ${currentAddress.toLowerCase()}.gated.so
                    </a>
                </p>
                <div class="action-buttons">
                    <button id="switch-account-btn" class="primary-btn">
                        Switch Account
                    </button>
                </div>
            </div>
        `;
      }

      window.showSuccessAndRedirect = (url) => {
        const container = document.querySelector('.access-message');
        container.innerHTML = `
      <div class="alert-check success-transition">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
          <path d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <p>Access granted! Redirecting to dashboard...</p>
      </div>
    `;
      }
      const styles = `
  .claim-container {
    max-width: 32rem;
    margin: 0 auto;
    padding: 1.5rem;
  }

  .claim-card {
    background: white;
    border-radius: 0.75rem;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
    border: 1px solid hsl(240 5.9% 90%);
  }

  .card-header {
    padding: 20px;
  }

  .card-title {
    padding:20px;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
    margin: 0;
    color: hsl(240 3.8% 46.1%);
  }

  .card-content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .text-muted {
    color: hsl(240 3.8% 46.1%);
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .address-code {
    font-family: ui-monospace, monospace;
    font-size: 0.875rem;
    background: hsl(240 4.8% 95.9%);
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    display: inline-block;
    color: hsl(240 5.9% 10%);
  }

  @media (max-width: 640px) {
    .claim-container {
      padding: 1rem;
    }
  }
`;

      // Add the styles to the document
      if (!document.getElementById('claim-page-styles')) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'claim-page-styles';
        styleSheet.textContent = styles;
        document.head.appendChild(styleSheet);
      }
      this.mainContent.innerHTML = `
  <div class="claim-container">
    <div class="claim-card">
        <h1 class="card-title">Claim This Page</h1>
      <div class="card-content">
        <div class="address-section">
          <p class="text-muted">This page belongs to STX address:</p>
          <code class="address-code">${stxAddress}</code>
        </div>
        ${contentToShow}
      </div>
    </div>
  </div>
    <img src=${gatedLogo} alt="Gated Logo" class="logo" />
`;
      if (!isSignedIn) {
        const connectButton = document.getElementById('connectWallet-button');
        if (connectButton) {
          connectButton.addEventListener('click', () => {
            window.connectWallet()
              .catch(error => {
                console.error('Failed to connect wallet:', error);
              });
          });
        }
      } else if (matchesPage) {
        // Dashboard redirect handler
        const dashboardBtn = document.getElementById('go-to-dashboard-btn');
        if (dashboardBtn) {
          dashboardBtn.addEventListener('click', () => {
            const dashboardUrl = this.getDashboardUrl(stxAddress);
            const container = document.querySelector('.access-message');
            container.innerHTML = `
                    <div class="alert-check success-transition">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                            <path d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>Access granted! Redirecting to dashboard...</p>
                    </div>
                `;
            setTimeout(() => {
              window.location.href = dashboardUrl;
            }, 1500);
          });
        }

        // Sign out handler
        const signOutBtn = document.getElementById('sign-out-btn');
        if (signOutBtn) {
          signOutBtn.addEventListener('click', () => {
            window.disconnectWallet();
          });
        }
      } else {
        // Switch account handler
        const switchAccountBtn = document.getElementById('switch-account-btn');
        if (switchAccountBtn) {
          switchAccountBtn.addEventListener('click', () => {
            window.connectWallet(true);
          });
        }
      }


    }, 500);
  }

  hideCreatePageModal() {
    const modal = document.getElementById('create-page-modal');
    const form = document.getElementById('create-page-form');
    if (modal) {
      modal.style.display = 'none';
      if (form) {
        form.reset();
        // Reset the counter displays
        document.getElementById('title-counter').textContent = '0';
        document.getElementById('description-counter').textContent = '0';
      }
    }
  }

  showCreatePageModal() {
    const MAX_TITLE_LENGTH = 64;
    const MAX_DESCRIPTION_LENGTH = 256;

    // First, inject the modal HTML if it doesn't exist
    if (!document.getElementById('create-page-modal')) {
      const modalHTML = `
    <div id="create-page-modal" class="modal" style="display: none;">
      <div class="modal-content">
      <div class="modal-header">
        <h2>Create new page</h2>
      </div>
      <div class="modal-body">
        <div id="form-errors" class="text-red-500 mb-4"></div>
        <form id="create-page-form" class="space-y-4">
          <div>
            <div class="create-page-title">Page Title</div>
            <input 
              type="text" 
              name="title" 
              id="title"
              maxlength="${MAX_TITLE_LENGTH}"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              placeholder="Enter page title" 
              required
            >
            <div class="char-count-title"><span id="title-counter">0</span>/${MAX_TITLE_LENGTH}</div>
          </div>
          <div>
            <div class="create-page-description">Description</div>
            <textarea
              name="description" 
              id="description"
              maxlength="${MAX_DESCRIPTION_LENGTH}"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              rows="3"
              placeholder="Enter page description"
              required
            ></textarea>
            <div class="char-count-title"><span id="description-counter">0</span>/${MAX_DESCRIPTION_LENGTH}</div>
          </div>
      </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary cancel-btn">Cancel</button>
          <button type="button" class="btn btn-primary confirm-btn">Next</button>
          </div>
    
        </form>
      </div>
    </div>
  `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
      // Setup one-time event listeners
      const modal = document.getElementById('create-page-modal');
      const form = document.getElementById('create-page-form');
      const cancelBtn = modal.querySelector('.cancel-btn');
      const confirmBtn = modal.querySelector('.confirm-btn');

      // Character counters
      ['title', 'description'].forEach(id => {
        const input = document.getElementById(id);
        const counter = document.getElementById(`${id}-counter`);
        input.addEventListener('input', () => {
          counter.textContent = input.value.length;
        });
      });

      // Cancel button handler
      cancelBtn.addEventListener('click', () => {
        modal.style.display = 'none';
        form.reset();
      });

      // Confirm button handler
      confirmBtn.addEventListener('click', async () => {
        const errorContainer = document.getElementById('form-errors');
        errorContainer.innerHTML = '';

        try {
          const stxAddress = this.auth.userSession.loadUserData().profile.stxAddress.mainnet;
          const title = form.querySelector('input[name="title"]').value.trim();
          const description = form.querySelector('textarea[name="description"]').value.trim();
          const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '').replace(/^-+/, '');

          if (title.length > MAX_TITLE_LENGTH) {
            errorContainer.innerHTML = `Title must be ${MAX_TITLE_LENGTH} characters or less`;
            return;
          }

          if (description.length > MAX_DESCRIPTION_LENGTH) {
            errorContainer.innerHTML = `Description must be ${MAX_DESCRIPTION_LENGTH} characters or less`;
            return;
          }

          if (!title || !description) {
            errorContainer.innerHTML = 'Please fill in all fields';
            return;
          }

          if (slug.length > MAX_TITLE_LENGTH) {
            errorContainer.innerHTML = 'Title generates too long of a URL after conversion';
            return;
          }

          localStorage.setItem('pendingPage', JSON.stringify({ title, description }));
          modal.style.display = 'none';
          form.reset();
          this.showPublishConfirmation(title, description, slug, stxAddress);
        } catch (error) {
          errorContainer.innerHTML = error.message;
        }
      });

      form.addEventListener('submit', (e) => e.preventDefault());


      // Modal close handlers
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.style.display = 'none';
          form.reset();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.style.display === 'flex') {
          modal.style.display = 'none';
          form.reset();
        }
      });
    }

    // Create button click handler
    const createBtn = document.querySelector('.create-btn');
    if (createBtn) {
      createBtn.onclick = () => {
        const modal = document.getElementById('create-page-modal');
        modal.style.display = 'flex';
        modal.querySelector('input[name="title"]').focus();
      };
    }
  }

  showPublishConfirmation(title, description, slug, stxAddress) {

    const confirmModal = document.createElement('div');
    confirmModal.id = 'confirm-modal';
    confirmModal.className = 'modal';

    confirmModal.innerHTML = `
  <div class="modal-content">
  <div class="modal-header">
    <h2>Confirm Page Creation</h2>
  </div>
  <div class="modal-body">
    <p>You are about to create a new page:</p>
    <div class="info-grid">
      <div class="info-item">
        <div class="info-label">Title</div>
        <div class="info-value">${title}</div>
      </div>
      <div class="info-item">
        <div class="info-label">Description</div>
        <div class="info-value">${description}</div>
      </div>
      <div class="info-item">
        <div class="info-label">URL</div>
        <div class="info-value url-text">${stxAddress}.gated.so/#/${slug}</div>
      </div>
    </div>
    <div class="modal-status"></div>
  </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary cancel-btn">Cancel</button>
      <button type="button" class="btn btn-primary confirm-btn">Mint Page</button>
    </div>
  </div>
`;
    document.body.appendChild(confirmModal);

    // Setup confirmation handlers
    const cancelBtn = confirmModal.querySelector('.cancel-btn');
    const confirmBtn = confirmModal.querySelector('.confirm-btn');
    const statusDiv = confirmModal.querySelector('.modal-status');


    const closeConfirmModal = () => {
      document.body.removeChild(confirmModal);
    };

    cancelBtn.addEventListener('click', closeConfirmModal);

    // Handle confirmation and contract call
    confirmBtn.addEventListener('click', async () => {
      try {

        const pinataApiUrl = 'https://api.pinata.cloud/pinning/pinJSONToIPFS';
        const pinataApiKey = process.env.PINATA_API_KEY;
        const pinataSecretApiKey = process.env.PINATA_SECRET_KEY;

        if (!pinataApiKey || !pinataSecretApiKey) {
          throw new Error('Missing Pinata credentials');
        }

        statusDiv.textContent = 'Uploading metadata to IPFS...';
        confirmBtn.disabled = true;

        const userSession = new UserSession();
        const userData = userSession.loadUserData();
        const senderAddress = userData.profile.stxAddress.mainnet;
        const contract = 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5.gated-pages';
        const gatedFee = 1000000;
        const imageCid = "bafkreifgvle7pvczsnxvb72j224fkxabctadqsfxl3jkrhw6gyhmrk3vua";

        const metadata = {
          sip: 16,
          name: title,
          description,
          image: `ipfs://${imageCid}`,
          attributes: [
            { trait_type: "Page Status", value: "Active" },
            { trait_type: "Festive Mode", value: "Off" }
          ],
          properties: {
            collection: "Gated Pages",
            total_supply: "1",
          },
          external_url: `https://${senderAddress.toLowerCase()}.gated.so/#/${slug}`
        };


        const ipfsResponse = await fetch(pinataApiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'pinata_api_key': pinataApiKey,
            'pinata_secret_api_key': pinataSecretApiKey,
          },
          body: JSON.stringify({
            pinataMetadata: {
              name: `createPage-${senderAddress}-${slug}-gated-pages`,
            },
            pinataContent: metadata
          })
        });


        if (!ipfsResponse.ok) {
          throw new Error('Failed to upload to IPFS');
        }

        const { IpfsHash } = await ipfsResponse.json();
        const metadataUri = `ipfs://${IpfsHash}`;
        console.log('Generated metadata:', JSON.stringify(metadata, null, 2));
        console.log('Uploaded to IPFS:', metadataUri);

        statusDiv.textContent = 'Calling smart contract...';

        // Prepare contract call
        const functionArgs = [
          stringAsciiCV(title),
          stringAsciiCV(description),
          stringAsciiCV(metadataUri)
        ];


        const postConditions = [
          Pc.principal(senderAddress).willSendEq(gatedFee).ustx()
        ];

        const options = {
          network: STACKS_MAINNET,
          contractAddress: contract.split('.')[0],
          contractName: contract.split('.')[1],
          functionName: 'mint-page',
          functionArgs: functionArgs,
          postConditions: postConditions,
          onFinish: data => {
            console.log('Transaction:', data);
            localStorage.removeItem('pendingPage');
            window.location.href = `/#/${slug}?tx=${data.txId}`;
          }
        };

        // Make the contract call
        await openContractCall(options);

      } catch (error) {
        console.error('Error creating page:', error);
        alert(error.message);
      } finally {
        closeConfirmModal();
      }
    });

    // Close on click outside
    confirmModal.addEventListener('click', (e) => {
      if (e.target === confirmModal) {
        closeConfirmModal();
      }
    });
  }

  showUpdateConfirmation(id, title, description, slug, stxAddress, active, contract, socialLinksData, contentBlocks, profilePhotoData, nftCollectionData, selectedNFTData) {
    // Early validation of contract type
    if (!contract) {
      console.error('Contract type is required');
      throw new Error('Contract type must be specified');
    }

    // Create modal first
    const confirmModal = document.createElement('div');
    confirmModal.id = 'confirm-modal';
    confirmModal.className = 'modal';

    // Define helper functions
    const closeConfirmModal = () => {
      document.body.removeChild(confirmModal);
    };

    const handleConfirm = async () => {
      try {
        // Show loading state
        const confirmBtn = confirmModal.querySelector('.confirm-btn');
        const originalText = confirmBtn.textContent;
        confirmBtn.textContent = 'Processing...';
        confirmBtn.disabled = true;

        // Prepare updated page data
        const updatedPageData = {
          id: id,
          title: title,
          description: description,
          active: active,
          contractType: contract,
          stxAddress: stxAddress,
          slug: slug,
          darkMode: document.documentElement.classList.contains('dark-theme'),
          profilePhoto: profilePhotoData,
          content: contentBlocks,
          metadata: {
            socialLinks: socialLinksData,
            nftCollection: nftCollectionData,
            contentBlocks: contentBlocks
          }
        };

        const isFestiveModeEnabled = !!selectedNFTData;

        // First update metadata
        const metadataResult = await handlePageUpdate({
          ...updatedPageData,
          owner: this.currentStxAddress,
          festive: isFestiveModeEnabled,
          ...(selectedNFTData || {})
        });

        // Prepare contract call
        const userData = userSession.loadUserData();
        const senderAddress = userData.profile.stxAddress.mainnet;
        const gatedFee = 1000000;

        // Update function arguments to match contract expectations
        const functionArgs = [
          uintCV(updatedPageData.id),                        // id
          stringAsciiCV(updatedPageData.title),              // title
          stringAsciiCV(updatedPageData.description),        // description
          boolCV(!!updatedPageData.active),                  // active
          stringAsciiCV(`ipfs://${metadataResult.ipfsHash}`) // metadata-uri
        ];

        const postConditions = [
          Pc.principal(senderAddress).willSendEq(gatedFee).ustx()
        ];

        const options = {
          contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
          contractName: 'gated-pages',
          functionName: 'update-page',
          functionArgs,
          network: STACKS_MAINNET,
          postConditions: postConditions,
          onFinish: (data) => {
            this.showNotification('Page updated successfully!');
          }
        };

        await openContractCall(options);
      } catch (error) {
        console.error('Error updating page:', error);

        // Show error in modal instead of alert
        const modalBody = confirmModal.querySelector('.modal-body');
        const errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        errorElement.innerHTML = `
        <i class="fa-solid fa-circle-exclamation"></i>
        <p>Error: ${error.message}</p>
      `;

        modalBody.appendChild(errorElement);

        // Reset button
        const confirmBtn = confirmModal.querySelector('.confirm-btn');
        confirmBtn.textContent = 'Try Again';
        confirmBtn.disabled = false;

        // Don't close modal on error
        return;
      }

      closeConfirmModal();
    };

    // Build minimal modal content - focused only on the blockchain transaction
    confirmModal.innerHTML = `
  <div class="modal-content ${localStorage.getItem('gatedDarkMode') === 'true' ? 'dark-theme' : ''}">
    <div class="modal-header">
      <h2>Confirm page update</h2>
    </div>
    
    <div class="modal-body">
      <div class="confirmation-message">
        <i class="fa-solid fa-triangle-exclamation warning-icon"></i>
        <p>You are about to submit a blockchain transaction to update your gated page.</p>
      </div>
      
      <div class="transaction-info">
        <p>This action will:</p>
        <ul>
          <li>Make a contract call to update your page</li>
          <li>Require approximately 1 STX for the transaction fee</li>
          <li>Update your page metadata on IPFS</li>
        </ul>
      </div>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary cancel-btn">Cancel</button>
      <button type="button" class="btn btn-primary confirm-btn">Confirm Update</button>
    </div>
  </div>
  `;

    // Setup event listeners for modal buttons
    const cancelBtn = confirmModal.querySelector('.cancel-btn');
    const confirmBtn = confirmModal.querySelector('.confirm-btn');

    cancelBtn.addEventListener('click', closeConfirmModal);
    confirmBtn.addEventListener('click', handleConfirm);

    // Handle clicking outside modal to close
    confirmModal.addEventListener('click', (e) => {
      if (e.target === confirmModal) {
        closeConfirmModal();
      }
    });

    // Append modal to body
    document.body.appendChild(confirmModal);

    // Return promise that resolves when modal is closed
    return new Promise((resolve) => {
      const observer = new MutationObserver((mutations) => {
        if (!document.body.contains(confirmModal)) {
          observer.disconnect();
          resolve();
        }
      });

      observer.observe(document.body, { childList: true });
    });
  }

  showDeactivateConfirmation(pageId, title, description, metadataUri, active, contract) {
    const confirmModal = document.createElement('div');
    confirmModal.id = 'confirm-modal';
    confirmModal.className = 'modal';

    // Get user's STX address from session
    const userSession = new UserSession();
    const userData = userSession.loadUserData();
    const stxAddress = userData.profile.stxAddress.mainnet;
    const senderAddress = userData.profile.stxAddress.mainnet;
    const gatedFee = 1000000;


    confirmModal.innerHTML = `
  <div class="modal-content">
      <div class="modal-header">
      <h2>Review and confirm deactivation</h2>
      </div>
      
      <div class="modal-body">
        <div class="info-grid">

        <div class="info-item">
              <div class="info-label">ID</div>
              <div class="info-value">${pageId}</div> 
          </div>         
          
          <div class="info-item">
              <div class="info-label">Title</div>
              <div class="info-value">${title}</div>
          </div>
          
          <div class="info-item">
              <div class="info-label">Description</div>
              <div class="info-value">${description}</div>
          </div>
          
          <div class="info-item">
              <div class="info-label">URL</div>
              <div class="info-value monospace">${stxAddress}.gated.so/#/${this.sanitizeUrl(title)}</div>
          </div>
          
          
        </div>
          <div class="modal-status"></div>
      </div>
      
      <div class="modal-footer">
          <button type="button" class="btn btn-secondary cancel-btn">Cancel</button>
          <button type="button" class="create-btn confirm-btn">Unpublish Page</button>
      </div>
  </div>
  `;

    document.body.appendChild(confirmModal);

    const statusDiv = confirmModal.querySelector('.modal-status');
    const cancelBtn = confirmModal.querySelector('.cancel-btn');
    const confirmBtn = confirmModal.querySelector('.confirm-btn');

    const closeConfirmModal = () => {
      document.body.removeChild(confirmModal);
    };

    cancelBtn.addEventListener('click', closeConfirmModal);

    confirmBtn.addEventListener('click', async () => {
      try {
        statusDiv.textContent = 'Updating metadata...';
        confirmBtn.disabled = true;
        cancelBtn.disabled = true;

        // Prepare the page update data
        const updatedPageData = {
          id: pageId,
          title: title,
          description: description,
          active: false,
          owner: stxAddress,
          contractType: contract,
          stxAddress: stxAddress,
          slug: this.sanitizeUrl(title),
          pageStatus: "Inactive"
        };

        // Update metadata with inactive status
        const metadataResult = await handlePageUpdate(updatedPageData);
        console.log(metadataResult);

        statusDiv.textContent = 'Preparing contract call...';


        // Prepare contract call arguments
        const functionArgs = [
          uintCV(pageId),
          stringAsciiCV(title),
          stringAsciiCV(description),
          boolCV(false), // Set active to false
          stringAsciiCV(`ipfs://${metadataResult.ipfsHash}`)
        ];

        const postConditions = [
          Pc.principal(senderAddress).willSendEq(gatedFee).ustx()
        ];

        // Prepare contract call options
        const options = {
          network: STACKS_MAINNET,
          contractAddress: 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5',
          contractName: 'gated-pages',
          functionName: 'update-page',
          functionArgs,
          postConditions: postConditions,
          onFinish: data => {
            console.log('Transaction submitted:', data);
            this.showNotification('Page deactivation transaction submitted', 'success');
            closeConfirmModal();

            if (data.txId) {
              window.location.href = `/dashboard?tx=${data.txId}`;
            }
          },
          onCancel: () => {
            this.showNotification('Transaction cancelled', 'info');
            closeConfirmModal();
          }
        };

        statusDiv.textContent = 'Please confirm the transaction in your wallet...';
        await openContractCall(options);

      } catch (error) {
        console.error('Error deactivating page:', error);
        statusDiv.textContent = `Error: ${error.message}`;
        confirmBtn.disabled = false;
        cancelBtn.disabled = false;
        this.showNotification('Failed to deactivate page: ' + error.message, 'error');
      }
    });


  }


  // Add this method to set up deactivation event listeners
  setupDeactivationHandlers() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('.delete-btn')) {
        if (this.currentEffect) {
          document.body.removeChild(this.currentEffect.canvas);
          this.currentEffect = null;
        }

        const pageData = JSON.parse(e.target.dataset.page);
        this.showDeactivateConfirmation(
          pageData.id,
          pageData.title,
          pageData.description,
          pageData.metadata?.uri || ''
        );
      }
    });
  }

formatAddress(address) {
  if (!address) return 'Unknown';
  
  // Return first 6 characters + ... + last 4 characters
  if (address.length <= 10) return address;
  
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

  renderAdminDashboard(stxAddress) {
    console.log('Rendering admin dashboard for:', stxAddress);

    this.mainContent.innerHTML = `
        <div class="admin-dashboard">
            <header class="dashboard-header">
              <div class="dashboard-header-text-container">
                                    <a href="https://${stxAddress}.gated.so" style="text-decoration: none;">
                    <img src="${gatedLogo}" div class="logo">
                    <div class="under-logo">Alpha 0.5</div>
                    </a>
                
                </div> 
               <div class="wallet-dropdown">
    <button id="wallet-dropdown-btn" class="class="dropdown-item"> 
      ${this.formatAddress(this.auth.getCurrentAddress())}
        <i class="fa-sharp-duotone fa-solid fa-chevron-down"></i>
  
    </button>
    <div id="wallet-dropdown-content" class="wallet-dropdown-content">
        <button onclick="window.disconnectWallet()" class="dropdown-item-dashboard">
           Logout <i class="fa-sharp-duotone fa-solid fa-arrow-right-from-bracket"></i> 
            
        </button>

    </div>
</div>
            </header>

            <div class="dashboard-content">
                <section class="sidebar">
                   <div class="dashboard-header-text">
                        Dashboard
                      </div>

                <hr style="/* border-bottom: navajowhite; */
                  background-color: #e8e8e8;
                  width: 100%;
                  height: 1px;
                  border: none;">
                  <div class="sidebar-header">
                  Menu
                  </div>
                  <div class="sidebar-list">
                    <div class="item-pages">Pages</div>
                    <div class="item-media">Media</div>
                    <div class="item-albums">Albums</div>
                  </div>
                </section>

                <section class="pages-section">
                    <div class="section-header">
                        <div class="section-header-text">
                          <div class="section-header-title">Your Pages</div>
                          <div class="section-header-subtitle">Pages you own. Secured by blockchain.</div>
                        </div>
                          <button class="create-btn">Create New Page</button>
                    </div>
                    <div id="pages-list" class="pages-list">
                        Loading pages from Blockchain...
                    </div>
                </section>
            </div>
        </div>
    `;

    // Add dropdown functionality after rendering


    // Initialize tab switching
    this.initializeSidebarTabs(stxAddress);

    // Initialize other dashboard functionality
    this.loadPages(stxAddress);
    this.showCreatePageModal();
    this.setupWalletDropdown();

    // Clear any page-only theme first, then restore user's saved preference
    if (typeof applyPageTheme === 'function') {
      applyPageTheme(false);
    }
    if (typeof initializeDarkModeToggle === 'function') {
      initializeDarkModeToggle(null);
    }
  }


  initializeSidebarTabs(stxAddress) {
    // First verify the elements exist
    const pagesTab = this.mainContent?.querySelector('.item-pages');
    const mediaTab = this.mainContent?.querySelector('.item-media');
    const albumsTab = this.mainContent?.querySelector('.item-albums');
    const contentSection = this.mainContent?.querySelector('.pages-section');

    const addTabStyles = () => {
      if (document.getElementById('tab-styles')) return;

      const styles = `
    .item-pages, .item-media, .item-albums {
      cursor: pointer;
      padding: 7px 15px;
      transition: all 0.2s ease;
    }

    .item-pages:hover, .item-media:hover, .item-albums:hover {
      background-color: #f3f4f6;
    }

    .item-pages.active, .item-media.active, .item-albums.active {
      background-color: #d2580b;
      font-weight: bold;
      color: white;
      border-radius:5px;
    }
  `;

      const styleSheet = document.createElement('style');
      styleSheet.id = 'tab-styles';
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    };

    if (!pagesTab || !mediaTab || !albumsTab || !contentSection) {
      console.error('Required elements not found for tab initialization');
      return;
    }

    // Initialize music player if it doesn't exist
    if (!window.musicPlayer) {
      window.musicPlayer = {
        isInitialized: false,
        currentTrackIndex: 0,
        audioPlayer: new Audio(),


        init() {
          if (this.isInitialized) return;
          this.setupAudioPlayer();
          this.isInitialized = true;
        },

        setupAudioPlayer() {
          this.audioPlayer.addEventListener('timeupdate', this.updateProgress.bind(this));
          this.audioPlayer.addEventListener('ended', this.handleTrackEnd.bind(this));
        },

        setCurrentTrack(index) {
          this.currentTrackIndex = index;
        },


        togglePlayPause() {
          if (this.audioPlayer.paused) {
            this.audioPlayer.play();
          } else {
            this.audioPlayer.pause();
          }
          this.updatePlayPauseButton();
        },

        updateProgress() {
          const progressBar = document.getElementById('progress-bar');
          const duration = document.getElementById('song-duration');

          if (progressBar && !isNaN(this.audioPlayer.duration)) {
            const percentage = (this.audioPlayer.currentTime / this.audioPlayer.duration) * 100;
            progressBar.value = percentage;
          }

          if (duration) {
            // Calculate remaining time instead of elapsed time
            const remainingTime = this.audioPlayer.duration - this.audioPlayer.currentTime;
            duration.textContent = this.formatTime(remainingTime);
          }
        },


        updatePlayerUI(song) {
          const albumArt = document.getElementById('album-art');
          const trackInfo = document.getElementById('track-info');
          const stickyPlayer = document.getElementById('music-player-sticky');

          if (albumArt) albumArt.src = song.imgUrl;
          if (trackInfo) trackInfo.textContent = `${song.songArtist} - ${song.songName}`;
          if (stickyPlayer) stickyPlayer.style.display = 'flex';
        },

        formatTime(seconds) {
          if (isNaN(seconds)) return "0:00";

          // Round down to nearest second to avoid fractional seconds
          seconds = Math.floor(seconds);

          const minutes = Math.floor(seconds / 60);
          const remainingSeconds = seconds % 60;

          // Format as M:SS
          return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
        },
      };
    }

    // Define content display functions first
    const showPagesContent = () => {
      contentSection.innerHTML = `
        <div class="section-header">
          <div class="section-header-text">
            <div class="section-header-title">Your Pages</div>
            <div class="section-header-subtitle">Pages you own. Secured by blockchain.</div>
          </div>
          <button class="create-btn">Create New Page</button>
        </div>
        <div id="pages-list" class="pages-list">
          Loading pages from Blockchain...
        </div>
      `;

      this.loadPages(stxAddress);
      this.showCreatePageModal();
    };

    const showAlbumsContent = () => {
      renderAlbumsSection(this);
    };

    const showMediaContent = () => {
      // First ensure musicPlayer exists
      if (!window.musicPlayer) {
        console.error('Music player not initialized');
        return;
      }

      contentSection.innerHTML = `
    <div class="section-header">
      <div class="section-header-text">
        <h2>${musicData.title}</h2>
        <div class="section-header-subtitle">${musicData.subtitle}</div>
      </div>
    </div>
    <div class="media-container">
      <div class="media-grid" id="media-grid"></div>
    </div>
    <div id="music-player-sticky" class="sticky-player">
      <div class="player-content">
        <img id="album-art" src="" alt="Album Art" class="album-art">
        <div class="track-info-container">
          <div id="track-info" class="track-info"></div>
          <div class="player-controls">
            <button id="prev-btn" class="control-btn">
              <i class="fa-solid fa-backward"></i>
            </button>
            <button id="play-pause-btn" class="control-btn">
              <i class="fa-solid fa-play"></i>
            </button>
            <button id="next-btn" class="control-btn">
              <i class="fa-solid fa-forward"></i>
            </button>
            <input 
              type="range" 
              id="volume-control" 
              min="0" 
              max="100" 
              value="50" 
              class="volume-slider"
            >
          </div>
        </div>
        <div class="progress-container">
          <input type="range" id="progress-bar" min="0" max="100" value="0">
          <span id="song-duration"></span>
        </div>
      </div>
    </div>
  `;



      requestAnimationFrame(() => {
        // Initialize grid first
        this.initializeMediaGrid();

        // Initialize music player if needed
        if (!window.musicPlayer.isInitialized) {
          window.musicPlayer.init();
        }


      });
    };


    const tabs = [pagesTab, mediaTab, albumsTab];
    const setActiveTab = (index) => {
      tabs.forEach((t, i) => t.classList.toggle('active', i === index));
    };

    const handlePagesClick = (e) => {
      e.preventDefault();
      setActiveTab(0);
      showPagesContent();
    };
    const handleMediaClick = (e) => {
      e.preventDefault();
      setActiveTab(1);
      showMediaContent();
    };
    const handleAlbumsClick = (e) => {
      e.preventDefault();
      setActiveTab(2);
      showAlbumsContent();
    };

    this.currentHandlers = {
      handlePagesClick,
      handleMediaClick,
      handleAlbumsClick
    };

    if (this._prevTabHandlers) {
      pagesTab.removeEventListener('click', this._prevTabHandlers.handlePagesClick);
      mediaTab.removeEventListener('click', this._prevTabHandlers.handleMediaClick);
      albumsTab.removeEventListener('click', this._prevTabHandlers.handleAlbumsClick);
    }
    this._prevTabHandlers = this.currentHandlers;

    pagesTab.addEventListener('click', handlePagesClick);
    mediaTab.addEventListener('click', handleMediaClick);
    albumsTab.addEventListener('click', handleAlbumsClick);

    setActiveTab(0);
    showPagesContent();
    addTabStyles();
    // Add styles
    this.addMediaStyles();


    // Add this helper method
    function updateStickyPlayerUI(controls) {
      const currentSong = musicData.songs[window.musicPlayer.currentTrackIndex];

      // Update album art
      if (controls.albumArt && currentSong.imgUrl) {
        controls.albumArt.src = currentSong.imgUrl;
      }

      // Update track info
      if (controls.trackInfo) {
        controls.trackInfo.textContent = `${currentSong.songArtist} - ${currentSong.songName}`;
      }

      // Update play/pause button
      if (controls.playPauseBtn) {
        controls.playPauseBtn.innerHTML = window.musicPlayer.audioPlayer.paused ?
          '<i class="fa-solid fa-play"></i>' :
          '<i class="fa-solid fa-pause"></i>';
      }

      // Show sticky player
      const stickyPlayer = document.getElementById('music-player-sticky');
      if (stickyPlayer) {
        stickyPlayer.style.display = 'flex';
      }
    }

    // Add this helper method
    function updateStickyPlayerProgress(controls) {
      if (!window.musicPlayer.audioPlayer) return;

      // Update progress bar
      if (controls.progressBar) {
        const percentage = (window.musicPlayer.audioPlayer.currentTime / window.musicPlayer.MAX_PLAY_TIME) * 100;
        controls.progressBar.value = percentage;
      }

      // Update duration display
      if (controls.durationDisplay) {
        const timeLeft = Math.ceil(window.musicPlayer.MAX_PLAY_TIME - window.musicPlayer.audioPlayer.currentTime);
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        controls.durationDisplay.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
    }

    // Add this helper method
    function addStickyPlayerStyles() {
      if (document.getElementById('sticky-player-styles')) return;

      const styles = `
    .sticky-player {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: white;
      padding: 1rem;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
      z-index: 1000;
    }

    .player-content {
      display: grid;
      grid-template-columns: auto 1fr auto;
      gap: 1rem;
      align-items: center;
    }

    .album-art {
      width: 50px;
      height: 50px;
      border-radius: 4px;
      object-fit: cover;
    }

    .track-info-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .player-controls {
      display: flex;
      gap: 1rem;
      align-items: center;
    }

    .control-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0.5rem;
      transition: opacity 0.2s;
    }

    .control-btn:hover {
      opacity: 0.8;
    }

    .progress-container {
      grid-column: 1 / -1;
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    #progress-bar {
      flex: 1;
    }

    #song-duration {
      min-width: 4ch;
      text-align: right;
    }
  `;

      const styleSheet = document.createElement('style');
      styleSheet.id = 'sticky-player-styles';
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    };


  }
  // Add this new method to your class

  // First, let's create a mapping between NFT names and track data
  TRACK_MAPPING = {
    'radio-silence': {
      songName: "Radio Silence",
      songArtist: "Josie Field",
      imgUrl: track1Image,
      audioUrl: track1Audio
    },
    'you-make-it-alright': {
      songName: "You Make It Alright",
      songArtist: "Ard Matthews",
      imgUrl: track2Image,
      audioUrl: track2Audio
    },
    'mortals': {
      songName: "Mortals",
      songArtist: "Arno Carstens",
      imgUrl: track3Image,
      audioUrl: track3Audio
    },
    'buzz-head': {
      songName: "Buzz Head",
      songArtist: "Kahn Morbee",
      imgUrl: track4Image,
      audioUrl: track4Audio
    },
    'grey': {
      songName: "Grey",
      songArtist: "Laurie Levine",
      imgUrl: track5Image,
      audioUrl: track5Audio
    },
    'exile': {
      songName: "Exile",
      songArtist: "Jacques Moolman",
      imgUrl: track6Image,
      audioUrl: track6Audio
    },
    'i-shouldnt-break': {
      songName: "I Shouldn't Break",
      songArtist: "Evert Snyman",
      imgUrl: track7Image,
      audioUrl: track7Audio
    },
    'bbq-to-braai': {
      songName: "BBQ to Braai",
      songArtist: "Xander",
      imgUrl: track8Image,
      audioUrl: track8Audio
    }
  };
  async initializeMediaGrid() {
    const mediaGrid = document.getElementById('media-grid');
    if (!mediaGrid || !musicData) return;

    try {
      const userData = this.auth.userSession.loadUserData();
      const userAddressMainnet = userData.profile.stxAddress.mainnet;

      const nftHoldingsUrl = `/api/proxy/stacks?principal=${userAddressMainnet}&limit=50`;
      const holdingsResponse = await fetch(nftHoldingsUrl);
      if (!holdingsResponse.ok) throw new Error('Failed to fetch NFT holdings');

      const holdingsData = await holdingsResponse.json();
      const ownedNFTs = new Set();

      if (holdingsData.results) {
        for (const nft of holdingsData.results) {
          const matches = nft.asset_identifier.match(/^(SP[A-Z0-9]+)\.([^:]+)::([^:]+)$/);
          if (matches &&
            matches[1] === 'SP2BRB6P0BK6T35DHTGXCV6MZ5TGRN5E0RKZ1T8B5' &&
            matches[2] === 'gated-005') {
            ownedNFTs.add(matches[3]);
          }
        }
      }

      const ownedTracks = Array.from(ownedNFTs)
        .map(nftName => this.TRACK_MAPPING[nftName])
        .filter(track => track);

      if (ownedTracks.length === 0) {
        mediaGrid.innerHTML = `
                <div class="no-tracks-message">
                    <p>No owned tracks found. Purchase tracks to start listening!</p>
                </div>
            `;
        return;
      }

      const testMode = false;
      const hasCompleteCollection = testMode ? true : ownedTracks.length === 8;
      console.log(`Collection Status: ${ownedTracks.length}/8 tracks owned`);
      console.log('Complete collection:', hasCompleteCollection);

      const gridHTML = `
            ${hasCompleteCollection ? `
                <div class="media-item" data-index="album">
                    <img src="${albumImage}" alt="Complete Album" />
                    <div class="play-overlay">
                        <i class="fa-solid fa-crown fa-2x" style="color: gold;"></i>
                    </div>
                    <div class="song-info">
                        <h3>Complete Collection</h3>
                        <p>${ownedTracks.length}/8 Tracks Owned</p>
                    </div>
                </div>
            ` : ''}
            ${ownedTracks.map((song, index) => `
                <div class="media-item" data-index="${index}">
                    <img src="${song.imgUrl}" alt="${song.songName}" />
                    <div class="play-overlay">
                        <i class="fa-solid fa-play fa-2x play-icon" style="color: white;"></i>
                        <i class="fa-solid fa-pause fa-2x pause-icon" style="color: white; display: none;"></i>
                    </div>
                    <div class="song-info">
                        <h3>${song.songName}</h3>
                        <p>${song.songArtist}</p>
                    </div>
                </div>
            `).join('')}
        `;

      mediaGrid.innerHTML = gridHTML;

      if (!window.musicPlayer.isInitialized) {
        window.musicPlayer.init();
      }

      if (ownedTracks.length > 0) {
        window.musicPlayer.loadTrack(0, ownedTracks, true);
      }

      const mediaItems = mediaGrid.querySelectorAll('.media-item:not(.non-playable)');
      mediaItems.forEach(item => {
        item.addEventListener('click', () => {
          const index = parseInt(item.dataset.index);
          if (!window.musicPlayer) return;

          if (index === 0 && !window.musicPlayer.audioPlayer.src) {
            window.musicPlayer.loadTrack(0, ownedTracks, true);
          }

          const isCurrentTrack = window.musicPlayer.currentTrackIndex === index;
          const isPlaying = !window.musicPlayer.audioPlayer.paused;

          if (isCurrentTrack && isPlaying) {
            window.musicPlayer.togglePlayPause();
          } else if (isCurrentTrack && !isPlaying) {
            window.musicPlayer.togglePlayPause();
          } else {
            window.musicPlayer.loadTrack(index, ownedTracks, true);
            setTimeout(() => window.musicPlayer.togglePlayPause(), 100);
          }
        });
      });

    } catch (error) {
      console.error('Error in initializeMediaGrid:', error);
      mediaGrid.innerHTML = `
            <div class="error-message">
                <p>Error loading your music collection. Please try again later.</p>
                <p>Error: ${error.message}</p>
            </div>
        `;
    }
  }


  updateStickyPlayerUI(controls) {
    if (!window.musicPlayer?.audioPlayer) return;

    const currentSong = musicData.songs[window.musicPlayer.currentTrackIndex];

    if (controls.albumArt) {
      controls.albumArt.src = currentSong.imgUrl;
    }

    if (controls.trackInfo) {
      controls.trackInfo.textContent = `${currentSong.songArtist} - ${currentSong.songName}`;
    }

    if (controls.playPauseBtn) {
      controls.playPauseBtn.innerHTML = window.musicPlayer.audioPlayer.paused ?
        '<i class="fa-solid fa-play"></i>' :
        '<i class="fa-solid fa-pause"></i>';
    }
  }

  // Update the updateStickyPlayerProgress method in your Router class
  updateStickyPlayerProgress(controls) {
    if (!window.musicPlayer?.audioPlayer?.duration) return;

    const currentTime = window.musicPlayer.audioPlayer.currentTime;
    const duration = window.musicPlayer.audioPlayer.duration;

    if (controls.progressBar) {
      controls.progressBar.value = (currentTime / duration) * 100;
    }

    if (controls.durationDisplay) {
      // Calculate remaining time
      const remainingTime = duration - currentTime;
      const minutes = Math.floor(remainingTime / 60);
      const seconds = Math.floor(remainingTime % 60);
      controls.durationDisplay.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  }

  // Separate method for styles
  addMediaStyles() {
    if (document.getElementById('media-grid-styles')) return;

    const styles = `
        .media-container {
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 20px;
        }

        .media-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
            gap: 20px;
            padding: 20px 0;
        }

        .media-item {
            position: relative;
            aspect-ratio: 1;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .media-item:hover {
            transform: translateY(-5px);
            box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }

        .media-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .media-item .play-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.2s ease;
        }

        .media-item:hover .play-overlay {
            opacity: 1;
        }

        .media-item .song-info {
            color: white;
            text-align: center;
            padding: 10px;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.7);
        }

        .media-item .song-info h3 {
            margin: 0;
            font-size: 0.9em;
            font-weight: 500;
        }

        .media-item .song-info p {
            margin: 5px 0 0;
            font-size: 0.8em;
            opacity: 0.8;
        }
    `;

    const styleSheet = document.createElement('style');
    styleSheet.id = 'media-grid-styles';
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }

  // Add this new method to handle dropdown setup
  setupWalletDropdown() {
    console.log('Setting up wallet dropdown');

    const style = document.createElement('style');
    style.textContent = `
    .wallet-dropdown-content {
      display: none;
      position: absolute;
      background: white;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      z-index: 100;
      margin-top: 8px; /* Gap between button and dropdown */
      right: 0; /* Align to right side of container */
    }

    .wallet-dropdown-content.show {
      display: block;
    }

    .wallet-btn {
      display: flex;
      align-items: center;
      gap: 8px; /* Space between text and icon */
    }

    /* Add gap below dropdown button */
    .wallet-dropdown {
      position: relative;
    }
  `;
    document.head.appendChild(style);


    const dropdownBtn = document.getElementById('wallet-dropdown-btn');
    const dropdownContent = document.getElementById('wallet-dropdown-content');

    if (!dropdownBtn || !dropdownContent) {
      console.error('Dropdown elements not found');
      return;
    }

    // Toggle dropdown on button click
    dropdownBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdownContent.classList.toggle('show');
      console.log('Dropdown toggled');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdownBtn.contains(e.target)) {
        dropdownContent.classList.remove('show');
      }
    });

    // Prevent dropdown from closing when clicking inside content
    dropdownContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  async loadUserPages(stxAddress) {
    try {
      const pagesList = document.getElementById('pages-list');
      const pages = await window.fetchPagesForAddress(stxAddress);

      if (pages.length === 0) {
        pagesList.innerHTML = `
      < div class="empty-state" >
          <p>You haven't created any pages yet.</p>
          <p>Click "Add New Page" to get started.</p>
        </ >
      `;
        return;
      }

      pagesList.innerHTML = pages.map(page => {
        const pageUrl = `${window.location.protocol}//${stxAddress}.${window.location.host}/#/${page.title}`;

        return `
          <div class="page-card">
            <div class="page-header">
              <h3 class="page-title">${page.title}</h3>
              <div class="url-container flex items-center gap-2">
                <p class="page-url truncate">${pageUrl}</p>
                <button
                  onclick="copyPageUrl('${pageUrl}')" 
                  class="copy-btn flex items-center p-2 hover:bg-gray-100 rounded"
                  title="Copy URL"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </button>
              </div>
            </div>
            <div class="page-actions">
              <!-- Use hash routing to prevent full page reload -->
              <a href="#/${page.title}" class="action-btn btn-primary">View Page</a>
            </div>
          </div>
        `;
      }).join('');

      // Add the copyPageUrl function to window
      window.copyPageUrl = async (url) => {
        try {
          await navigator.clipboard.writeText(url);
          const btn = event.target.closest('.copy-btn');

          // Show feedback
          const originalHTML = btn.innerHTML;
          btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          `;

          // Reset after 2 seconds
          setTimeout(() => {
            btn.innerHTML = originalHTML;
          }, 2000);
        } catch (err) {
          console.error('Failed to copy:', err);
        }
      };

    } catch (error) {
      console.error('Error loading user pages:', error);
      const pagesList = document.getElementById('pages-list');
      pagesList.innerHTML = `
        <div class="empty-state">
          <p>Error loading pages. Please try again later.</p>
        </div>
      `;
    }
  }



  initializeAudioControls() {
    const playPauseBtn = document.getElementById('play-pause-btn');
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');

    playPauseBtn?.addEventListener('click', togglePlayPause);
    prevBtn?.addEventListener('click', playPreviousTrack);
    nextBtn?.addEventListener('click', playNextTrack);
  }

  // Add this helper method if you don't already have it
  escapeHtml(unsafe) {
    if (!unsafe) return '';
    return unsafe
      .toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  async loadPageContent(stxAddress, pageTitle) {
    try {
      const nftContent = document.getElementById('nft-content');
      const content = await window.fetchPageContent(stxAddress, pageTitle);

      nftContent.innerHTML = `
        <div class="nft-card">
          <h2>${content.nftName}</h2>
          <p>${content.description}</p>
          <button onclick="window.mintNFT('${content.id}')">
            Mint NFT (${content.price} STX)
          </button>
        </div>
      `;
    } catch (error) {
      console.error('Error loading page content:', error);
    }
  }
}

// Add the copy function
async function copyPageUrl(url) {
  try {
    await navigator.clipboard.writeText(url);
    const btn = event.target.closest('.copy-btn');

    // Show feedback
    const originalHTML = btn.innerHTML;
    btn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    `;

    // Reset after 2 seconds
    setTimeout(() => {
      btn.innerHTML = originalHTML;
    }, 2000);
  } catch (err) {
    console.error('Failed to copy:', err);
  }
}

// Initialize router
window.router = new Router();

// Export for module usage
export default Router;